/*===========================
##########MAIN MENU##########

=====PLUGINS=====    
  #BOOTSTRAP INPUT SPINNER
        
=====CUSTOM JS=====        

    #MOBILE NAVIGATION
    #SEARCH
    #CART DRAWER
    #SELECT CALLBACK
    #ADD TO CART
    #SLIDERS
    #COMPARE PRODUCTS
    #ADDON ACCESSORIES

===========================*/


/*===============================
	#Bootstrap Input Spinner
==============================*/

/*=====bootstrap-input-spinner.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

/*=====FIXES=====*/
$(document).ready(function () {
  $(".form-control").attr("aria-label", "Quantity Input");
});

(function ($) {
  "use strict";

  // the default editor for parsing and rendering
  var I18nEditor = function (props, element) {
    var locale = props.locale || "en-US";

    this.parse = function (customFormat) {
      var numberFormat = new Intl.NumberFormat(locale);
      var thousandSeparator =
        numberFormat.format(11111).replace(/1/g, "") || ".";
      var decimalSeparator = numberFormat.format(1.1).replace(/1/g, "");
      return parseFloat(
        customFormat
          .replace(new RegExp(" ", "g"), "")
          .replace(new RegExp("\\" + thousandSeparator, "g"), "")
          .replace(new RegExp("\\" + decimalSeparator), ".")
      );
    };

    this.render = function (number) {
      var decimals = parseInt(element.getAttribute("data-decimals")) || 0;
      var digitGrouping = !(
        element.getAttribute("data-digit-grouping") === "false"
      );
      var numberFormat = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: digitGrouping,
      });
      return numberFormat.format(number);
    };
  };

  var triggerKeyPressed = false;
  var originalVal = $.fn.val;
  $.fn.val = function (value) {
    if (arguments.length >= 1) {
      for (var i = 0; i < this.length; i++) {
        if (this[i]["bootstrap-input-spinner"] && this[i].setValue) {
          this[i].setValue(value);
        }
      }
    }
    return originalVal.apply(this, arguments);
  };

  $.fn.inputSpinner = function (methodOrProps) {
    if (methodOrProps === "destroy") {
      this.each(function () {
        if (this["bootstrap-input-spinner"]) {
          this.destroyInputSpinner();
        } else {
          //console.warn("element", this, "is no bootstrap-input-spinner");
        }
      });
      return this;
    }

    var props = {
      inventoryTotal: $("#variantInventory").attr('value'),
      decrementButton: "&minus;", // button text
      incrementButton: "&plus;", // ..
      groupClass: "", // css class of the resulting input-group
      buttonsClass: "btn-cnx",
      buttonsWidth: "2.5rem",
      textAlign: "center", // alignment of the entered number
      autoDelay: 500, // ms threshold before auto value change
      autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
      buttonsOnly: true, // set this `true` to disable the possibility to enter or paste the number via keyboard
      keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
      locale: navigator.language, // the locale, per default detected automatically from the browser
      editor: I18nEditor, // the editor (parsing and rendering of the input)
      // the template of the input
      template:
        '<div class="input-group ${groupClass}">' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button>' +
        '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" min="0" max="${inventoryTotal}" class="form-control form-control-text-input"/>' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button>' +
        "</div>",
    };

    for (var option in methodOrProps) {
      // noinspection JSUnfilteredForInLoop
      props[option] = methodOrProps[option];
    }

    var html = props.template
      .replace(/\${groupClass}/g, props.groupClass)
      .replace(/\${buttonsWidth}/g, props.buttonsWidth)
      .replace(/\${buttonsClass}/g, props.buttonsClass)
      .replace(/\${decrementButton}/g, props.decrementButton)
      .replace(/\${incrementButton}/g, props.incrementButton)
      .replace(/\${textAlign}/g, props.textAlign)
      .replace(/\${inventoryTotal}/g, props.inventoryTotal);

    this.each(function () {
      if (this["bootstrap-input-spinner"]) {
        //console.warn("element", this, "is already a bootstrap-input-spinner");
      } else {
        var $original = $(this);
        $original[0]["bootstrap-input-spinner"] = true;
        $original.hide();
        $original[0].inputSpinnerEditor = new props.editor(props, this);

        var autoDelayHandler = null;
        var autoIntervalHandler = null;

        var $inputGroup = $(html);
        var $buttonDecrement = $inputGroup.find(".btn-decrement");
        var $buttonIncrement = $inputGroup.find(".btn-increment");
        var $input = $inputGroup.find("input");
        var $label = $("label[for='" + $original.attr("id") + "']");
        if (!$label[0]) {
          $label = $original.closest("label");
        }

        var min = null;
        var max = null;
        var step = null;

        updateAttributes();

        var value = parseFloat($original[0].value);
        var pointerState = false;

        var prefix = $original.attr("data-prefix") || "";
        var suffix = $original.attr("data-suffix") || "";

        if (prefix) {
          var prefixElement = $(
            '<span class="input-group-text">' + prefix + "</span>"
          );
          $inputGroup.find("input").before(prefixElement);
        }
        if (suffix) {
          var suffixElement = $(
            '<span class="input-group-text">' + suffix + "</span>"
          );
          $inputGroup.find("input").after(suffixElement);
        }

        $original[0].setValue = function (newValue) {
          setValue(newValue);
        };
        $original[0].destroyInputSpinner = function () {
          destroy();
        };

        var observer = new MutationObserver(function () {
          updateAttributes();
          setValue(value, true);
        });
        observer.observe($original[0], { attributes: true });

        $original.after($inputGroup);

        setValue(value);

        $input
          .on("paste input change focusout", function (event) {
            var newValue = $input[0].value;
            var focusOut = event.type === "focusout";
            newValue = $original[0].inputSpinnerEditor.parse(newValue);
            setValue(newValue, focusOut);
            dispatchEvent($original, event.type);
          })
          .on("keydown", function (event) {
            if (props.keyboardStepping) {
              if (event.which === 38) {
                // up arrow pressed
                event.preventDefault();
                if (!$buttonDecrement.prop("disabled")) {
                  stepHandling(step);
                }
              } else if (event.which === 40) {
                // down arrow pressed
                event.preventDefault();
                if (!$buttonIncrement.prop("disabled")) {
                  stepHandling(-step);
                }
              }
            }
          })
          .on("keyup", function (event) {
            // up/down arrow released
            if (
              props.keyboardStepping &&
              (event.which === 38 || event.which === 40)
            ) {
              event.preventDefault();
              resetTimer();
            }
          });

        // decrement button
        onPointerDown($buttonDecrement[0], function () {
          if (!$buttonDecrement.prop("disabled")) {
            pointerState = true;
            stepHandling(-step);
          }
        });
        // increment button
        onPointerDown($buttonIncrement[0], function () {
          if (!$buttonIncrement.prop("disabled")) {
            pointerState = true;
            stepHandling(step);
          }
        });
        onPointerUp(document.body, function () {
          if (pointerState === true) {
            resetTimer();
            dispatchEvent($original, "change");
            pointerState = false;
          }
        });
      }

      function setValue(newValue, updateInput) {
        if (updateInput === undefined) {
          updateInput = true;
        }
        if (isNaN(newValue) || newValue === "") {
          $original[0].value = "";
          if (updateInput) {
            $input[0].value = "";
          }
          value = NaN;
        } else {
          newValue = parseFloat(newValue);
          newValue = Math.min(Math.max(newValue, min), max);
          $original[0].value = newValue;
          if (updateInput) {
            $input[0].value = $original[0].inputSpinnerEditor.render(newValue);
          }
          value = newValue;
        }
      }

      function destroy() {
        $original.prop("required", $input.prop("required"));
        observer.disconnect();
        resetTimer();
        $input.off("paste input change focusout");
        $inputGroup.remove();
        $original.show();
        $original[0]["bootstrap-input-spinner"] = undefined;
        if ($label[0]) {
          $label.attr("for", $original.attr("id"));
        }
      }

      function dispatchEvent($element, type) {
        if (type) {
          setTimeout(function () {
            var event;
            if (typeof Event === "function") {
              event = new Event(type, { bubbles: true });
            } else {
              // IE
              event = document.createEvent("Event");
              event.initEvent(type, true, true);
            }
            $element[0].dispatchEvent(event);
          });
        }
      }

      function stepHandling(step) {
        calcStep(step);
        resetTimer();
        if (props.autoInterval !== undefined) {
          autoDelayHandler = setTimeout(function () {
            autoIntervalHandler = setInterval(function () {
              calcStep(step);
            }, props.autoInterval);
          }, props.autoDelay);
        }
      }

      function calcStep(step) {
        if (isNaN(value)) {
          value = 0;
        }
        setValue(Math.round(value / step) * step + step);
        dispatchEvent($original, "input");
      }

      function resetTimer() {
        clearTimeout(autoDelayHandler);
        clearTimeout(autoIntervalHandler);
      }

      function updateAttributes() {
        // copy properties from original to the new input
        if ($original.prop("required")) {
          $input.prop("required", $original.prop("required"));
          $original.removeAttr("required");
        }
        $input.prop("placeholder", $original.prop("placeholder"));
        $input.attr("inputmode", $original.attr("inputmode") || "decimal");
        var disabled = $original.prop("disabled");
        var readonly = $original.prop("readonly");
        $input.prop("disabled", disabled);
        $input.prop("readonly", readonly || props.buttonsOnly);
        $buttonIncrement.prop("disabled", disabled || readonly);
        $buttonDecrement.prop("disabled", disabled || readonly);
        if (disabled || readonly) {
          resetTimer();
        }
        var originalClass = $original.prop("class");
        var groupClass = "";
        // sizing
        if (/form-control-sm/g.test(originalClass)) {
          groupClass = "input-group-sm";
        } else if (/form-control-lg/g.test(originalClass)) {
          groupClass = "input-group-lg";
        }
        var inputClass = originalClass.replace(/form-control(-(sm|lg))?/g, "");
        $inputGroup.prop(
          "class",
          "input-group " + groupClass + " " + props.groupClass
        );
        $input.prop("class", "form-control " + inputClass);
        
        // update the main attributes
        min =
          isNaN($original.prop("min")) || $original.prop("min") === ""
            ? -Infinity
            : parseFloat($original.prop("min"));
        max =
          isNaN($original.prop("max")) || $original.prop("max") === ""
            ? Infinity
            : parseFloat($original.prop("max"));
        step = parseFloat($original.prop("step")) || 1;
        if ($original.attr("hidden")) {
          $inputGroup.attr("hidden", $original.attr("hidden"));
        } else {
          $inputGroup.removeAttr("hidden");
        }
        if ($original.attr("id")) {
          $input.attr("id", $original.attr("id") + "_MP_cBdLN29i2");
          if ($label[0]) {
            $label.attr("for", $input.attr("id"));
          }
        }
      }
    });

    return this;
  };

  function onPointerUp(element, callback) {
    element.addEventListener("mouseup", function (e) {
      callback(e);
    });
    element.addEventListener("touchend", function (e) {
      callback(e);
    });
    element.addEventListener("keyup", function (e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        triggerKeyPressed = false;
        callback(e);
      }
    });
  }

  function onPointerDown(element, callback) {
    element.addEventListener("mousedown", function (e) {
      if (e.button === 0) {
        e.preventDefault();
        callback(e);
      }
    });
    element.addEventListener("touchstart", function (e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      callback(e);
    });
    element.addEventListener("keydown", function (e) {
      if ((e.keyCode === 32 || e.keyCode === 13) && !triggerKeyPressed) {
        triggerKeyPressed = true;
        callback(e);
      }
    });
  }
})(jQuery);

/*=====custom-editors.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

var customEditors = {
  RawEditor: function (props, element) {
    this.parse = function (customFormat) {
      // parse nothing
      return customFormat;
    };
    this.render = function (number) {
      // render raw
      return number;
    };
  },
  TimeEditor: function (props, element) {
    // could be implemented more elegant maybe, but works
    this.parse = function (customFormat) {
      var trimmed = customFormat.trim();
      var sign = 1;
      if (trimmed.charAt(0) === "-") {
        sign = -1;
        trimmed = trimmed.replace("-", "");
      }
      var parts = trimmed.split(":");
      var hours = 0,
        minutes;
      if (parts[1]) {
        hours = parseInt(parts[0], 10);
        minutes = parseInt(parts[1], 10);
      } else {
        minutes = parseInt(parts[0], 10);
      }
      return (hours * 60 + minutes) * sign;
    };
    this.render = function (number) {
      var minutes = Math.abs(number % 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var hours;
      if (number >= 0) {
        hours = Math.floor(number / 60);
        return hours + ":" + minutes;
      } else {
        hours = Math.ceil(number / 60);
        return "-" + Math.abs(hours) + ":" + minutes;
      }
    };
  },
};

/*=====Bootstrap Input Spinner Implementation=====*/

$("input[type='number']").inputSpinner();

/*==============================
  #Navigation Accesibility
==============================*/

document.addEventListener('DOMContentLoaded', function() {
  // Show dropdown when parent menu item receives focus
  $('.menu--main-item > a').on('focus', function() {
    var $parent = $(this).parent();
    var $dropdown = $parent.find('.menu--dropdown');
    
    // Add a class to track which dropdown is open via keyboard
    $parent.addClass('keyboard-focus');
    
    // Check if this is in the secondary or tertiary navigation
    if ($parent.closest('.site-navigation--secondary, .site-navigation--tertiary').length) {
      // Secondary or tertiary navigation (mega menu)
      $dropdown.css({
        'display': 'block'
      });
    } else {
      // Primary navigation (regular dropdown)
      $dropdown.css({
        'max-height': '2000px',
        'display': 'block',
        'border': '1px solid black',
        'box-shadow': '1px 1px 1px black'
      });
    }
  });
  
  // Keep dropdown open when focus moves to items inside the dropdown
  $('.menu--dropdown a').on('focus', function() {
    var $menuItem = $(this).closest('.menu--main-item');
    var $dropdown = $menuItem.find('.menu--dropdown');
    
    $menuItem.addClass('keyboard-focus');
    
    // Check if this is in the secondary or tertiary navigation
    if ($menuItem.closest('.site-navigation--secondary, .site-navigation--tertiary').length) {
      // Secondary or tertiary navigation (mega menu)
      $dropdown.css({
        'display': 'block'
      });
    } else {
      // Primary navigation (regular dropdown)
      $dropdown.css({
        'max-height': '2000px',
        'display': 'block',
        'border': '1px solid black',
        'box-shadow': '1px 1px 1px black'
      });
    }
  });
  
  // Close dropdown when focus moves away from the menu item and its dropdown
  $(document).on('focusin', function(e) {
    // If the new focus is not within a menu item that has keyboard-focus class
    if (!$(e.target).closest('.keyboard-focus').length) {
      // Handle primary navigation dropdowns
      $('.keyboard-focus').not('.site-navigation--secondary .keyboard-focus, .site-navigation--tertiary .keyboard-focus').removeClass('keyboard-focus')
        .find('.menu--dropdown').css({
          'max-height': '0',
          'border': 'none',
          'box-shadow': 'none'
        });
      
      // Handle secondary and tertiary navigation dropdowns (mega menu)
      $('.site-navigation--secondary .keyboard-focus, .site-navigation--tertiary .keyboard-focus').removeClass('keyboard-focus')
        .find('.menu--dropdown').css({
          'display': 'none'
        });
    }
  });
  
  // Close dropdown when Escape key is pressed
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $('.keyboard-focus').length) {
      // Handle primary navigation dropdowns
      $('.keyboard-focus').not('.site-navigation--secondary .keyboard-focus, .site-navigation--tertiary .keyboard-focus').removeClass('keyboard-focus')
        .find('.menu--dropdown').css({
          'max-height': '0',
          'border': 'none',
          'box-shadow': 'none'
        });
      
      // Handle secondary and tertiary navigation dropdowns (mega menu)
      $('.site-navigation--secondary .keyboard-focus, .site-navigation--tertiary .keyboard-focus').removeClass('keyboard-focus')
        .find('.menu--dropdown').css({
          'display': 'none'
        });
      
      // Return focus to the parent menu item that was previously focused
      if (document.activeElement && $(document.activeElement).closest('.menu--dropdown').length) {
        $(document.activeElement).closest('.menu--main-item').find('> a').focus();
      }
    }
  });
  
  // Add handler for the last focusable element in each dropdown
  // This ensures the dropdown closes when tabbing past the last element
  $('.menu--dropdown a:last').on('keydown', function(e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      var $menuItem = $(this).closest('.menu--main-item');
      
      // Close the dropdown
      $menuItem.removeClass('keyboard-focus');
      
      // Check if this is in the secondary or tertiary navigation
      if ($menuItem.closest('.site-navigation--secondary, .site-navigation--tertiary').length) {
        $menuItem.find('.menu--dropdown').css({
          'display': 'none'
        });
      } else {
        $menuItem.find('.menu--dropdown').css({
          'max-height': '0',
          'border': 'none',
          'box-shadow': 'none'
        });
      }
    }
  });
});

// Add keyboard accessibility for cart icon
$(document).ready(function() {

// Add event listener for tab key navigation in the cart drawer
$(document).ready(function() {
  $('.cart-drawer-body').on('keydown', function(e) {
    if (e.key === 'Tab' && $(this).hasClass('open')) {
      const focusableElements = $(this).find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      
      if (focusableElements.length === 0) return;
      
      const lastElement = focusableElements[focusableElements.length - 1];
      
      // If tabbing forward from the last element, close the cart
      if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        
        // Store the next element to focus after closing
        const allFocusableElements = $('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const cartIconIndex = allFocusableElements.index($('.icons--cart-icon-button'));
        let nextElement = null;
        
        if (cartIconIndex !== -1 && cartIconIndex + 1 < allFocusableElements.length) {
          nextElement = allFocusableElements[cartIconIndex + 1];
        }
        
        // Close the cart
        closeCart();
        
        // Focus on the next element after a delay
        if (nextElement) {
          setTimeout(function() {
            nextElement.focus();
          }, 150);
        }
      }
    }
  });
});

  // Add keyboard support for the cart icon button
  $('.icons--cart-icon-button').on('keydown', function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      openCart();
    }
  });
  
  // Add Escape key support to close the cart
  $(document).on('keydown', function(e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && $('.cart-drawer-body').hasClass('open')) {
      closeCart();
      // Return focus to the cart icon button for better accessibility
      setTimeout(function() {
        $('.icons--cart-icon-button').focus();
      }, 100);
    }
  });
});

// Updated cart open function
var openCart = function () {
  // Adjust cart drawer position before opening
  adjustCartDrawerPosition();
  
  // Animate the cart icon
  cartIconAnimation.animateToCartDrawer();
  
  // Show the cart drawer and make it accessible
  $(".cart-drawer-body").addClass("open");
  $(".cart-drawer-body").removeAttr("inert");
  $(".cart-drawer-body").attr("aria-hidden", "false");
  $(".body-blackout").removeClass("cloak");
  $("body").addClass("locked");
  
  // Enable all focusable elements inside the cart drawer
  const cartDrawer = $('.cart-drawer-body');
  const focusableElements = cartDrawer.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
  focusableElements.each(function() {
    $(this).attr('tabindex', '0');
  });
  
  // Set focus to the first focusable element in the cart drawer after it opens
  setTimeout(function() {
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }, 300); // Small delay to ensure the drawer is fully open
};

// 2. Modify the closeCart function to return focus to the cart icon button
// Add this inside the closeCart function, just before the closing brace
setTimeout(function() {
  $('.icons--cart-icon-button').focus();
}, 100);

// 3. Add a cart drawer-specific event listener for tab navigation
// Add this as a separate function after the cart icon keyboard support
$(document).ready(function() {
  // Add event listener to the cart drawer for tab key navigation
  $('.cart-drawer-body').on('keydown', function(e) {
    if (e.key === 'Tab' && $(this).hasClass('open')) {
      const focusableElements = $(this).find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      
      if (focusableElements.length === 0) return;
      
      const lastElement = focusableElements[focusableElements.length - 1];
      
      // If tabbing forward from the last element, close the cart
      if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        
        // Store the next element to focus after closing
        const allFocusableElements = $('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const cartIconIndex = allFocusableElements.index($('.icons--cart-icon-button'));
        let nextElement = null;
        
        if (cartIconIndex !== -1 && cartIconIndex + 1 < allFocusableElements.length) {
          nextElement = allFocusableElements[cartIconIndex + 1];
        }
        
        // Close the cart
        closeCart();
        
        // Focus on the next element after a delay
        if (nextElement) {
          setTimeout(function() {
            nextElement.focus();
          }, 150);
        }
      }
    }
  });
});

/*===========================
    #MOBILE NAVIGATION 
===========================*/

// OPEN AND CLOSE MENU

$('.hamburger-menu').on('click', function() {
    let isChecked = $('#hamburger').prop('checked');

    if (isChecked) {
        $('body').addClass('locked');
        $('.body-blackout').removeClass('cloak');
    } else {
        $('body').removeClass('locked');
        $('.body-blackout').addClass('cloak');
        $('.menu--slideout').removeClass('active');
    }
});

// CLOSE MENU ON ESCAPE KEY
$(document).on('keydown', function(e) {
    if (e.keyCode == 27) {
        
        if ($('#hamburger').prop('checked')) {
            $('#hamburger').prop('checked', false);
            
            // Remove locked class from body and hide blackout
            $('body').removeClass('locked');
            $('.body-blackout').addClass('cloak');
            
            // If there's an active submenu, close it
            $('.menu--slideout.active').removeClass('active');
        }
    }
});

// CLOSE MENU ON CLICK OF BODY BLACKOUT
$(document).ready(function() {
    $('.body-blackout').on('click', function() {
        $('#hamburger').prop('checked', false);
        $('body').removeClass('locked');
        $('.body-blackout').addClass('cloak');
        $('.menu--slideout.active').removeClass('active');
    });
});

// OPEN AND CLOSE SUB MENU

$('.slideout-master').on('click', function() {
    const slideoutMenu = $(this).find('.menu--slideout');
    slideoutMenu.addClass('active');
});

$('.slideout-sub').on('click', function(e) {
    e.stopPropagation();
    $(this).closest('.menu--slideout').removeClass('active');
});

// ADJUST MOBILE MENU POSITIONING FOR ANNOUNCEMENT BAR

function adjustSidebarPosition(){
    // Get the announcement bar height
    const announcementBarHeight = $('.announcement-bar').outerHeight() || 0;
    
    // Set the top position of the sidebar navigation
    // $('.sidebar-navigation').css('top', announcementBarHeight + 'px');    
}

    // Run on page load
$(document).ready(function() {
    adjustSidebarPosition();
});

    // Run whenever the window is resized
$(window).on('resize', function() {
    adjustSidebarPosition();
});

// ADJUST CART DRAWER POSITIONING FOR SCROLL POSITION
function adjustCartDrawerPosition() {
  const scrollPosition = window.scrollY || window.pageYOffset;
  const announcementBarHeight = $('.announcement-bar').outerHeight() || 0;
  const cartDrawer = $('.cart-drawer-body');
  
  if (scrollPosition > announcementBarHeight) {
    // When scrolled down, position the cart drawer at the top of the viewport
    cartDrawer.css({
      'top': '0',
      'height': '100vh'
    });
  } else {
    // When at the top of the page, position the cart drawer below the announcement bar
    cartDrawer.css({
      'top': announcementBarHeight + 'px',
      'height': `calc(100vh - ${announcementBarHeight}px)`
    });
  }
}

// Run on page load
$(document).ready(function() {
  adjustSidebarPosition();
  adjustCartDrawerPosition(); // Initialize cart drawer position
});

// Run whenever the window is resized or scrolled
$(window).on('resize', function() {
  adjustSidebarPosition();
  adjustCartDrawerPosition();
});

$(window).on('scroll', function() {
  adjustCartDrawerPosition();
});

/**/

$(".site-navigation-body__icons--search").on("click", function () {
  $(".slideout-search-bar").toggleClass("show");
});

$(".site-navigation-body__icons--search").keypress(function (e) {
  if ( event.which == 13 ) {
    $(".slideout-search-bar").toggleClass("show");
  }
});

/*==================
    #SEARCH
==================*/

$(document).ready(function() {
    // Toggle search overlay
    $('.icons--search-icon, .icons--search-icon-button').on('click', function() {
      // Get the position of the search icon for more precise animation      
      var $searchIcon = $(this);
      var iconPosition = $searchIcon.offset();     
      var iconWidth = $searchIcon.width();
      var iconHeight = $searchIcon.height();
      
      // Set the transform-origin dynamically based on the icon's position
      $('.search-bar-wrapper').css({
        'transform-origin': (iconPosition.left + iconWidth/2) + 'px ' + (iconPosition.top + iconHeight/2) + 'px'
      }).addClass('active');
      
      setTimeout(function() {
        $('.search-input').focus();
      }, 400);
    });
    
    // Handle keyboard interaction for search icon
    $('.icons--search-icon-button').on('keydown', function(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        // Trigger the click event to open the search
        $(this).trigger('click');
      }
    });
  });
  
  // Close search overlay
  $('body').on('click','.search-close', function() {
    $('.search-bar-wrapper').removeClass('active');
    // Return focus to the search icon button when search is closed
    $('.icons--search-icon-button').focus();
  });
  
  // Close on escape key
  $(document).keyup(function(e) {
    if (e.key === "Escape" && $('.search-bar-wrapper').hasClass('active')) {
      $('.search-bar-wrapper').removeClass('active');
      // Return focus to the search icon button when search is closed
      $('.icons--search-icon-button').focus();
    }
  });

/*=======================
  #Cart Drawer
=======================*/
function updateProgressBar() {
  const includedShippingDiv = document.querySelector('.included-shipping');
  const progressBar = document.querySelector('.included-shipping .progress-bar');
  const shippingIncludedAmount = document.querySelector('.shipping-included-amount');
  let freeShipAmount = parseInt(includedShippingDiv.dataset.freeShipAmount);
  let currentCartTotal = parseInt(includedShippingDiv.dataset.total);
  let amountLeft = (freeShipAmount - currentCartTotal) / 100;
  const progressPercentage = ((currentCartTotal / freeShipAmount).toFixed(2) * 100);
  progressBar.style.width = `${progressPercentage}%`;
  progressBar.ariaValueNow = progressPercentage;
  
  let formattedAmountLeft = (amountLeft <= 0) ? 0 : amountLeft.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2     
  });

  if (formattedAmountLeft <= 0) {
    document.querySelector('#free-ship-eligible .not-eligible-text').classList.add('d-none');
    document.querySelector('#free-ship-eligible .eligible-text').classList.remove('d-none');
  }
  else {
    document.querySelector('#free-ship-eligible .not-eligible-text').classList.remove('d-none');
    document.querySelector('#free-ship-eligible .eligible-text').classList.add('d-none');
  }
  shippingIncludedAmount.innerHTML = formattedAmountLeft;
}

// Cart icon animation controller
const cartIconAnimation = {
  isOpen: false,
  cartIconClone: null,
  
  // Initialize the animation
  init: function() {
    // Create a fixed cart icon that will be used for the animation
    this.createFixedCartIcon();
    
    // Set up event listeners
    this.setupEventListeners();
  },
  
  // Create a fixed cart icon that will be used for the animation
  createFixedCartIcon: function() {
    // Get the original cart icon
    const originalCartIcon = document.querySelector('.icons--cart-icon svg');
    
    if (originalCartIcon) {
      // Create a container for the fixed cart icon
      const fixedIconContainer = document.createElement('div');
      fixedIconContainer.className = 'fixed-cart-icon';
      fixedIconContainer.style.position = 'fixed';
      fixedIconContainer.style.zIndex = '1001';
      fixedIconContainer.style.cursor = 'pointer';
      fixedIconContainer.style.display = 'none';
      
      // Clone the cart icon
      this.cartIconClone = originalCartIcon.cloneNode(true);
      fixedIconContainer.appendChild(this.cartIconClone);
      
      // Add to the body
      document.body.appendChild(fixedIconContainer);
      
      // Add click event to the fixed icon
      fixedIconContainer.addEventListener('click', function() {
        if (cartIconAnimation.isOpen) {
          closeCart();
        } else {
          openCart();
        }
      });
    }
  },
  
  // Set up event listeners
  setupEventListeners: function() {
    // Original cart icon click
    const cartIcon = document.querySelector('.icons--cart-icon');
    if (cartIcon) {
      // Remove existing click handlers and add our new one
      $(cartIcon).off('click').on('click', function(e) {
        e.preventDefault();
        openCart();
      });
    }
  },
  
  // Animate the cart icon to the top of the cart drawer
  animateToCartDrawer: function() {
    const originalIcon = document.querySelector('.icons--cart-icon');
    const fixedIcon = document.querySelector('.fixed-cart-icon');
    const cartDrawer = document.querySelector('.cart-drawer-body');
    
    if (originalIcon && fixedIcon && cartDrawer) {
      // Get the positions
      const originalRect = originalIcon.getBoundingClientRect();
      
      // Position the fixed icon over the original
      fixedIcon.style.top = originalRect.top + 'px';
      fixedIcon.style.left = originalRect.left + 'px';
      fixedIcon.style.right = 'auto'; // Clear any right value
      fixedIcon.style.display = 'block';
      
      // Calculate the target position (top right of cart drawer)
      const cartRect = cartDrawer.getBoundingClientRect();
      
      // Position at the top right corner of the cart drawer, with proper padding
      const targetTop = (cartRect.top + 20) + 'px';
      
      // Adjust right position based on screen size
      let targetRight = '20px'; // Default for mobile
      
      // Check if we're on desktop (screen width > 768px)
      if (window.innerWidth > 768) {
        targetRight = '60px'; // Further to the right on desktop to avoid the title
      }
      
      // Scale the icon slightly larger for better visibility as a close button
      anime({
        targets: '.fixed-cart-icon svg',
        scale: 1.2,
        duration: 500,
        easing: 'easeOutQuad'
      });
      
      // Animate the icon to the target position
      anime({
        targets: '.fixed-cart-icon',
        top: targetTop,
        right: targetRight,
        left: 'auto', // Explicitly clear the left property
        duration: 500,
        easing: 'easeOutQuad',
        begin: function() {
          // Immediately clear the left property to avoid conflict with right
          fixedIcon.style.left = 'auto';
        }
      });
      
      // Check if both paths exist before attempting to animate
      const cartPath = document.querySelector('#cart-icon-path');
      const closePath = document.querySelector('#close-icon-path');
      
      if (cartPath && closePath) {
        // Animate the icon path to the close icon
        anime({
          targets: '.fixed-cart-icon #cart-icon-path',
          d: [
            { value: cartPath.getAttribute('d') },
            { value: closePath.getAttribute('d') }
          ],
          duration: 400,
          easing: 'easeInOutQuad'
        });
      }
      
      // Hide the original icon
      originalIcon.style.visibility = 'hidden';
      
      this.isOpen = true;
    }
  },
  
   // Animate the cart icon back to its original position ***
   animateToOriginal: function() {
    const originalIcon = document.querySelector('.icons--cart-icon');
    const fixedIcon = document.querySelector('.fixed-cart-icon');
    
    if (originalIcon && fixedIcon) {
      // Get the original position
      const originalRect = originalIcon.getBoundingClientRect();
      
      // Ensure the fixed icon has the same dimensions as the original
      const originalSvg = originalIcon.querySelector('svg');
      const fixedSvg = fixedIcon.querySelector('svg');
      
      if (originalSvg && fixedSvg) {
        fixedSvg.setAttribute('width', originalSvg.getAttribute('width'));
        fixedSvg.setAttribute('height', originalSvg.getAttribute('height'));
      }
      
      // Check if both paths exist before attempting to animate
      const cartPath = document.querySelector('#cart-icon-path');
      const closePath = document.querySelector('#close-icon-path');
      
      // First, animate the path back to cart icon shape
      if (cartPath && closePath) {
        anime({
          targets: '.fixed-cart-icon #cart-icon-path',
          d: [
            { value: closePath.getAttribute('d') },
            { value: cartPath.getAttribute('d') }
          ],
          duration: 350, // Faster transformation
          easing: 'easeInOutQuad'
        });
      }
      
      // Scale the icon back to original size
      anime({
        targets: '.fixed-cart-icon svg',
        scale: 1,
        duration: 400,
        easing: 'easeOutQuad'
      });
      
      // Get current position before animating
      const currentLeft = fixedIcon.getBoundingClientRect().left;
      const currentTop = fixedIcon.getBoundingClientRect().top;
      
      // Set current position explicitly to avoid jumps
      fixedIcon.style.top = currentTop + 'px';
      fixedIcon.style.right = 'auto';
      fixedIcon.style.left = currentLeft + 'px';
      
      // Check if we're on mobile (screen width <= 768px)
      const isMobile = window.innerWidth <= 768;
      
      // Adjust animation parameters based on device
      const duration = isMobile ? 350 : 450; // Faster on mobile
      const easing = isMobile ? 'easeOutSine' : 'easeOutQuad'; // Gentler easing on mobile
      
      // Show original icon earlier on mobile to avoid flicker
      if (isMobile) {
        // For mobile, show original icon sooner
        setTimeout(function() {
          originalIcon.style.visibility = 'visible';
        }, 200); // Much earlier on mobile
      } else {
        // For desktop, show near the end
        setTimeout(function() {
          originalIcon.style.visibility = 'visible';
        }, 350);
      }
      
      // Animate back to the original position
      anime({
        targets: '.fixed-cart-icon',
        top: originalRect.top + 'px',
        left: originalRect.left + 'px',
        duration: duration,
        easing: easing,
        complete: function() {
          // Hide the fixed icon after animation completes
          fixedIcon.style.display = 'none';
          // Ensure original icon is visible (backup)
          originalIcon.style.visibility = 'visible';
        }
      });
      
      this.isOpen = false;
    }
  }
};

/**
 * Sets up keyboard navigation for the cart drawer
 * Implements keyboard accessibility for the cart icon and drawer
 */
function setupCartKeyboardNavigation() {
  // Add keyboard support for the cart icon button to open the cart with Enter key
  $('.icons--cart-icon-button').on('keydown', function(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      openCart();
    }
  });
  
  // Add Escape key support to close the cart and return focus to the cart icon
  $(document).on('keydown', function(e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && $('.cart-drawer-body').hasClass('open')) {
      closeCart();
      // Return focus to the cart icon button for better accessibility
      setTimeout(function() {
        $('.icons--cart-icon-button').focus();
      }, 100);
    }
  });
  
  // Add tab key navigation for the cart drawer
  $('.cart-drawer-body').on('keydown', function(e) {
    if (e.key === 'Tab' && $(this).hasClass('open')) {
      const focusableElements = $(this).find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
      
      if (focusableElements.length === 0) return;
      
      const lastElement = focusableElements[focusableElements.length - 1];
      
      // If tabbing forward from the last element, close the cart
      if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        
        // Store the next element to focus after closing
        const allFocusableElements = $('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const cartIconIndex = allFocusableElements.index($('.icons--cart-icon-button'));
        let nextElement = null;
        
        if (cartIconIndex !== -1 && cartIconIndex + 1 < allFocusableElements.length) {
          nextElement = allFocusableElements[cartIconIndex + 1];
        }
        
        // Close the cart
        closeCart();
        
        // Focus on the next element after a delay
        if (nextElement) {
          setTimeout(function() {
            nextElement.focus();
          }, 150);
        }
      }
    }
  });
}

$(document).ready(function() {
  updateProgressBar();
  
  // Initialize the cart icon animation
  cartIconAnimation.init();
  
  // Set up keyboard navigation for the cart drawer
  setupCartKeyboardNavigation();
  
  // Set focus to the company logo when the page loads and manage tab order
  function setupInitialFocus() {
    // First, ensure all interactive elements except the company logo are not focusable on page load
    const searchIcon = document.querySelector('.icons--search-icon-button');
    const cartIcon = document.querySelector('.icons--cart-icon-button');
    const costcoNextLink = document.querySelector('.costco-next-link');
    
    if (searchIcon) searchIcon.setAttribute('tabindex', '-1');
    if (cartIcon) cartIcon.setAttribute('tabindex', '-1');
    if (costcoNextLink) costcoNextLink.setAttribute('tabindex', '-1');
    
    // Get the company logo link
    const companyLogoLink = document.querySelector('.company-logo-link');
    if (companyLogoLink) {
      // Ensure it has tabindex="1" to make it the first focusable element
      companyLogoLink.setAttribute('tabindex', '1');
      
      // Focus the company logo
      companyLogoLink.focus();
      
      // After the logo receives focus, restore the tabindex values for other elements
      setTimeout(function() {
        if (searchIcon) searchIcon.setAttribute('tabindex', '2');
        if (cartIcon) cartIcon.setAttribute('tabindex', '3');
        if (costcoNextLink) costcoNextLink.setAttribute('tabindex', '4');
      }, 100);
    }
  }
  
  // Run on document ready
  setupInitialFocus();
  
  // Also run when the window is fully loaded
  $(window).on('load', setupInitialFocus);
  
  // Run again after a short delay to ensure it works
  setTimeout(setupInitialFocus, 500);
  
  // Run one more time after a longer delay as a final fallback
  setTimeout(setupInitialFocus, 1000);
});

// Updated cart close function
var closeCart = function () {
  // Animate the cart icon back
  cartIconAnimation.animateToOriginal();
  
  // Hide the cart drawer and make it inaccessible to screen readers and keyboard
  $(".body-blackout").addClass("cloak");
  $(".cart-drawer-body").removeClass("open");
  $(".cart-drawer-body").attr("inert", "");
  $(".cart-drawer-body").attr("aria-hidden", "true");
  $("body").removeClass("locked");
  
  // Make all focusable elements inside the cart drawer unfocusable
  const cartDrawer = $('.cart-drawer-body');
  const focusableElements = cartDrawer.find('a, button, input, select, textarea, [tabindex]');
  focusableElements.each(function() {
    $(this).attr('tabindex', '-1');
  });
  
  // Return focus to the cart icon button for better accessibility
  setTimeout(function() {
    $('.icons--cart-icon-button').focus();
  }, 100);
};

var trashCan =
  '<svg width="25px" height="25px" viewBox="0 0 1024.00 1024.00" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000FF" stroke="#000000FF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M667.8 362.1H304V830c0 28.2 23 51 51.3 51h312.4c28.4 0 51.4-22.8 51.4-51V362.2h-51.3z" fill="#ffffff"></path><path d="M750.3 295.2c0-8.9-7.6-16.1-17-16.1H289.9c-9.4 0-17 7.2-17 16.1v50.9c0 8.9 7.6 16.1 17 16.1h443.4c9.4 0 17-7.2 17-16.1v-50.9z" fill="#ffffff"></path><path d="M733.3 258.3H626.6V196c0-11.5-9.3-20.8-20.8-20.8H419.1c-11.5 0-20.8 9.3-20.8 20.8v62.3H289.9c-20.8 0-37.7 16.5-37.7 36.8V346c0 18.1 13.5 33.1 31.1 36.2V830c0 39.6 32.3 71.8 72.1 71.8h312.4c39.8 0 72.1-32.2 72.1-71.8V382.2c17.7-3.1 31.1-18.1 31.1-36.2v-50.9c0.1-20.2-16.9-36.8-37.7-36.8z m-293.5-41.5h145.3v41.5H439.8v-41.5z m-146.2 83.1H729.5v41.5H293.6v-41.5z m404.8 530.2c0 16.7-13.7 30.3-30.6 30.3H355.4c-16.9 0-30.6-13.6-30.6-30.3V382.9h373.6v447.2z" fill="#000000FF"></path><path d="M511.6 798.9c11.5 0 20.8-9.3 20.8-20.8V466.8c0-11.5-9.3-20.8-20.8-20.8s-20.8 9.3-20.8 20.8v311.4c0 11.4 9.3 20.7 20.8 20.7zM407.8 798.9c11.5 0 20.8-9.3 20.8-20.8V466.8c0-11.5-9.3-20.8-20.8-20.8s-20.8 9.3-20.8 20.8v311.4c0.1 11.4 9.4 20.7 20.8 20.7zM615.4 799.6c11.5 0 20.8-9.3 20.8-20.8V467.4c0-11.5-9.3-20.8-20.8-20.8s-20.8 9.3-20.8 20.8v311.4c0 11.5 9.3 20.8 20.8 20.8z" fill="#000000FF"></path></g></svg>';
var emptyCartMessage = $(".cart-drawer-body__body").data("empty-cart-title");

// Main function that updates the cart drawer
var updateCartDrawer = function (event) {

  
  $.ajax({
    type: "get",
    url: window.Shopify.routes.root + "cart.js",
    dataType: "json",
    success: function (response) {
      // Parse cart response into json
      var cart = response;
      console.log('update cart drawer', cart);

      const cartTotalPrice = cart.total_price;
      document.querySelector('.included-shipping').dataset.total = cartTotalPrice;
      updateProgressBar();

      // Set Cart Qty in icon
      var cartCount = cart.item_count;
      //desktop
      $(".announcement-bar-body__icons--cart-count").html(cartCount);
      //mobile
      $(".site-navigation-body__icons--cart-count").html(cartCount);

      var cartItems = [];
      // Add HTML of each item to the cart
      $(cart.items).each(function () {
        var vTitle = this.variant_title;
        if (vTitle == null) {
          vTitle = "";
        }
        let image = this.image;
        let variantQuantity = $("#variantInventory").attr('value')
        var item = `
          <div class="col-12 mt-3 mb-1 border-bottom pb-3 cart_item" data-var-id="${this.variant_id}">
            <div class="row">

              <div class="col-4 cart_item__image">
                <a href="${this.url}"><img src="${image}" alt="${this.product_title}"></a>
              </div>

              <div class="col-8 cart_item__title">
                <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                  <div class="product-vendor">${this.vendor}</div>
                  <div class="cart_item__title--product"><a href="${this.url}">${this.product_title}</a></div>`;
                  for (let option of this.options_with_values) {
                    if(option.value != 'Default Title') {
                      item += `<div class="pt-1"><span class="fs-14">${option.name}: ${option.value}</span></div>`;
                    }
                  }
              item += `<div class="d-inline-block"><b class="cart-price">${Shopify.formatMoney(this.price)}</b></div>`;
              if (this.product_type !== 'Swatch') {
                item += `
                  <div class="cart_item__input">
                    <input class="form-control-sm" type="number" value="${this.quantity}">
                  </div>`;
              }

              item += `
                </div>
              </div>

              <div class="col text-end position-absolute end-0 delete cart_item__delete">
                  ${trashCan}
              </div>

            </div>`;
        cartItems.push(item);
      });

      // Clear cart items HTML
      $(".cart-drawer-body__body .cart-item-wrapper").empty();

      for (let cartItem of cartItems) {
        $(".cart-drawer-body__body .cart-item-wrapper").append(cartItem);
      }

      // Initialize inputSpinner on cart quantity inputs
      $(".cart-drawer-body__body input[type='number']").inputSpinner({
        buttonsClass: "btn-cnx",
        buttonsWidth: "2rem"
      });

      // Handle number inputs without inputSpinner
      $(".cart-drawer-body__body input[type='number']").on('change', function() {
        var qty = parseInt($(this).val()) || 1;
        if (qty < 1) qty = 1;
        $(this).val(qty);
      });

      $(".cart-drawer-body__footer--subtotal--subtotal").html(
        "" + Shopify.formatMoney(cart.items_subtotal_price)
      );

      if (cartItems.length > 0) {
        $(".empty-cart-wrapper").addClass("d-none");
        $(".cart-drawer-body__footer").removeClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").removeClass("d-none");
      } else {
        $(".empty-cart-wrapper").removeClass("d-none");
        $(".cart-drawer-body__footer").addClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").addClass("d-none");
      }

      $("#cart-overlay").fadeOut();
      // Display cart
      openCart();

  let baseTotal = Shopify.formatMoney(cart.items_subtotal_price)
  let shippingThreshold =  4500   ;
  //console.log(baseTotal);
  //console.log(shippingThreshold);
    }, //Cart success function
    error: function (err) {
      // console.log(err);
    },
  });
};

// OPEN CART DRAWER
$(".open-cart-drawer").on("click", function () {
  openCart();
});

$(".open-cart-drawer").keypress(function(event) {
   if (event.which == 13) {
   openCart();    
   }       
});

// CLOSE WHEN CLICKING X
$(".cart-drawer-hamburger").on("click", function () {
  closeCart();
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  closeCart();
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    closeCart();
  }
});

// update cart when qty is changed
$(".cart-drawer-body__body").on("change", "input", function () {
  var qty = $(this).val() < 0 ? 0 : $(this).val();
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = qty;
  $("#cart-overlay").show();
  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      // $("body").trigger("requestCartUpdate");
      updateCartDrawerSilently(response);
    },
    error: function (jqXHR, err) {
      $("#cart-overlay").fadeOut();

      
       // Check status code
        if (jqXHR.status === 422) {
            // display error wherever you want to  
          let variantInventory = $('#variantInventory').val()
          let currentInventory = $('.form-control-sm').val()
          let newQty = qty-1
          console.log(variantInventory+' - '+currentInventory);
          
          
          if(currentInventory > variantInventory){
            alert('You cannot add more of this item to your cart.');          
            $('.form-control-sm').val(newQty);
            $('.btn-cnx.btn-plus').addClass('pickles');
          }

        }
      // if it's not last one Move Along else update the cart number with the current quantity
          // if (Shopify.queue.length) {
          //     Shopify.moveAlong()
          // }

      
    },
  });
});

// update cart when line is removed
$(".cart-drawer-body__body").on("click", ".delete svg", function () {
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = 0;
  
  // Show loading overlay
  $("#cart-overlay").show();

  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      // Directly update the cart without triggering animation
      updateCartDrawerSilently(response);
    },
    error: function (err) {
      $("#cart-overlay").fadeOut();
    },
  });
});

// Function to update cart without animation
function updateCartDrawerSilently(response) {
  var cart = response;
  
  // Update cart count
  var cartCount = cart.item_count;
  $(".announcement-bar-body__icons--cart-count").html(cartCount);
  $(".site-navigation-body__icons--cart-count").html(cartCount);

  var cartItems = [];
  // Add HTML of each item to the cart
  $(cart.items).each(function () {
    var vTitle = this.variant_title;
    if (vTitle == null) {
      vTitle = "";
    }
    let image = this.image;
    let variantQuantity = $("#variantInventory").attr('value')
    var item = `
      <div class="col-12 mt-3 mb-1 border-bottom pb-3 cart_item" data-var-id="${this.variant_id}">
        <div class="row">

          <div class="col-4 cart_item__image">
            <a href="${this.url}"><img src="${image}" alt="${this.product_title}"></a>
          </div>

          <div class="col-8 cart_item__title">
            <div class="h-100 d-flex flex-column align-items-start justify-content-between">
            <div class="product-vendor">${this.vendor}</div>
              <div class="cart_item__title--product"><a href="${this.url}">${this.product_title}</a></div>`;
              for (let option of this.options_with_values) {
                item += `<div class="pt-1"><span class="fs-14">${option.name}: ${option.value}</span></div>`;
              }
              item += `<div class="d-inline-block"><b class="cart-price">${Shopify.formatMoney(this.price)}</b></div>`;
              if (this.product_type !== 'Swatch') {
                item += `
                  <div class="cart_item__input">
                    <input class="form-control-sm" type="number" value="${this.quantity}">
                  </div>`;
              }
              item += `
            </div>
          </div>

          <div class="col text-end position-absolute end-0 delete cart_item__delete">
              ${trashCan}
          </div>

        </div>`;
    cartItems.push(item);
  });

  // Clear cart items HTML
  $(".cart-drawer-body__body .cart-item-wrapper").empty();

  for (let cartItem of cartItems) {
    $(".cart-drawer-body__body .cart-item-wrapper").append(cartItem);
  }

  // Initialize inputSpinner on cart quantity inputs AFTER adding them to the DOM
  $(".cart-drawer-body__body input[type='number']").inputSpinner({
    buttonsClass: "btn-cnx",
    buttonsWidth: "2rem"
  });

  // Remove the basic number input handler as it's not needed with inputSpinner
  // $(".cart-drawer-body__body input[type='number']").on('change', function() {
  //   var qty = parseInt($(this).val()) || 1;
  //   if (qty < 1) qty = 1;
  //   $(this).val(qty);
  // });

  $(".cart-drawer-body__footer--subtotal--subtotal").html(
    "" + Shopify.formatMoney(cart.items_subtotal_price)
  );

  if (cartItems.length > 0) {
    $(".empty-cart-wrapper").addClass("d-none");
    $(".cart-drawer-body__footer").removeClass("d-none");
    $(".cart-drawer-body__body .cart-item-wrapper").removeClass("d-none");
  } else {
    $(".empty-cart-wrapper").removeClass("d-none");
    $(".cart-drawer-body__footer").addClass("d-none");
    $(".cart-drawer-body__body .cart-item-wrapper").addClass("d-none");
  }

  $("#cart-overlay").fadeOut();
}

// Listen for Cart Update event
$(document).on("requestCartUpdate", updateCartDrawer);

/*=======================
    #Select Callback
=======================*/

// Listen for Cart Update event
$("body").on("requestCartUpdate", updateCartDrawer);

// Product variant selection callback
// Product variant selection callback
var selectCallback = function (variant, selector) {
  if (variant) {
    var costcoPrice = Shopify.formatMoney(variant.price);
    var regularPrice = Shopify.formatMoney(variant.compare_at_price);
    
    // Update prices on product page
    $(".product-template__body--price .costco-price span").html(costcoPrice);
    $(".product-template__body--price .regular-price span").html(regularPrice);
    
    // Update variant availability
    if (variant.available) {
      // We have a valid product variant, so enable the submit button
      $('form[action="/cart/add"] [type="submit"]').prop('disabled', false).removeClass('disabled').val('Add to Cart');
    } else {
      // Variant is sold out, disable the submit button
      $('form[action="/cart/add"] [type="submit"]').prop('disabled', true).addClass('disabled').val('Sold Out');
    }
    
    // Update variant SKU if it exists
    if (variant.sku) {
      $('#sku').text(variant.sku);
    }
    
    // Whether the variant is in stock or not, update the price display
    if (variant.compare_at_price > variant.price) {
      // Show sale price and crossed-out compare price
      $('.product-template__body--price .regular-price').removeClass('d-none');
      
      // Change label to "Promo Price" for the sale price (first price)
      $('.product-template__body--price .costco-price').contents().first().replaceWith("Promo Price");
      
      // Make sure the regular price label says "Costco Price" (second price)
      $('.product-template__body--price .regular-price').contents().first().replaceWith("Costco Price");
    } else {
      // No sale, hide the compare price
      $('.product-template__body--price .regular-price').addClass('d-none');
      
      // Change label back to "Costco Price" for the regular price
      $('.product-template__body--price .costco-price').contents().first().replaceWith("Costco Price");
    }
    
    // Filter product images based on selected variant
    filterProductImages(variant);
  } else {
    // The variant doesn't exist, disable submit button
    $('form[action="/cart/add"] [type="submit"]').prop('disabled', true).addClass('disabled').val('Unavailable');
  }

// if (variant && variant['title']) {
//     $('.variant-color-selected').text(variant['title']);
// }
  // console.log(variant['title']);

  // console.log(variant)
};


/**
 * Filter product images based on selected variant
 * Uses slick slider's slickFilter and slickUnfilter methods
 * @param {Object} variant - The selected variant object
 */
function filterProductImages(variant) {
  // Check if slick is initialized before trying to filter
  if (!$(".product-image-slider__body").hasClass("slick-initialized") || 
      !$(".product-image-slider__thumbnails").hasClass("slick-initialized")) {
    console.log("Slick sliders not initialized yet");
    return; // Exit if sliders aren't initialized
  }
  
  // First, unfilter all slides to start fresh
  $(".product-image-slider__body").slick("slickUnfilter");
  $(".product-image-slider__thumbnails").slick("slickUnfilter");
  
  // Reset any existing filter classes
  $(".slick-slide").removeClass("variant-filter");
  
  if (!variant) {
    console.log("No variant provided, showing all images");
    // Reindex all slides when showing everything
    reindexSlides();
    return; // Exit and show all images if no variant
  }
  
  // Get variant options that we want to filter by
  var filterOptions = [];
  
  // Collect all option values from the variant
  for (var i = 1; i <= 3; i++) {
    var optionKey = 'option' + i;
    if (variant[optionKey]) {
      // Clean up the option value for comparison with image filenames
var optionValue = variant[optionKey].toString().toLowerCase()
    .replace(/\s*-\s*/g, '-')    // Remove spaces around hyphens
    .replace(/\s+/g, '-')        // Replace spaces with hyphens
    .replace(/-+/g, '-')         // Collapse multiple hyphens into one
    .replace(/[^a-z0-9-àâäéèêëïîôöùûüÿçñ]/g, ''); // Remove special characters but keep accented chars
      
      if (optionValue) {
        console.log(`Here we are: ${optionValue}`);
        filterOptions.push(optionValue);
      }
    }
  }
  
  if (filterOptions.length === 0) {
    console.log("No filter options found in variant");
    reindexSlides();
    return; // Exit if no filter options found
  }
  
  console.log("Filtering by options:", filterOptions);
  
  // Add filter class to matching slides
  $(".product-image-slider__body .slick-slide, .product-image-slider__thumbnails .slick-slide").each(function() {
    var $slide = $(this);
    var slideIndex = $slide.data('slick-index') || 'unknown';
    var imgAlt = $slide.find('img').attr('alt') || '';
    var imgSrc = $slide.find('img').attr('src') || '';
    var dataAlt = $slide.find('img').data('alt') || '';
    var dataFileName = $slide.find('img').data('file-name') || '';
    
    // Convert all to lowercase for case-insensitive comparison
    imgAlt = imgAlt.toLowerCase();
    imgSrc = imgSrc.toLowerCase();
    dataAlt = dataAlt.toString().toLowerCase();
    dataFileName = dataFileName.toString().toLowerCase();
    
    // Check if all of the filter options match the image attributes
    var matched = filterOptions.every(function(option) {
      var altMatch = imgAlt.includes(option);
      var srcMatch = imgSrc.includes(option);
      var dataAltMatch = dataAlt.includes(option);
      var dataFileNameMatch = dataFileName.includes(option);
      
      // DEBUG: Log matches for first few images
      if (slideIndex < 3) {
        // console.log("Checking option '" + option + "':");
        // console.log("  Alt match:", altMatch);
        // console.log("  Src match:", srcMatch);
        // console.log("  Data alt match:", dataAltMatch);
        // console.log("  Data filename match:", dataFileNameMatch);
      }
      
      return altMatch || srcMatch || dataAltMatch || dataFileNameMatch;
    });
    
    if (matched) {
      $slide.addClass("variant-filter");
      if (slideIndex < 3) {
        // console.log("Image " + slideIndex + " MATCHED - adding variant-filter class");
      }
    } else if (slideIndex < 3) {
      // console.log("Image " + slideIndex + " did NOT match");
    }
  });
  
  // Count how many slides match our filter
  var filteredCount = $(".product-image-slider__body .variant-filter").length;
  
  if (filteredCount > 0) {
    // Apply the filter to both sliders
    $(".product-image-slider__body").slick("slickFilter", ".variant-filter");
    $(".product-image-slider__thumbnails").slick("slickFilter", ".variant-filter");
    
    // Re-index the filtered slides starting from 0
    reindexFilteredSlides();
    
    // Go to first slide after filtering and reindexing
    $(".product-image-slider__body").slick("slickGoTo", 0);
    
    // console.log("Filtered to " + filteredCount + " images");
  } else {
    // console.log("No images matched the filter criteria, showing all images");
    // If no images match, don't apply any filter (show all) and reindex
    reindexSlides();
  }
}

/**
 * Reindex all visible slides starting from 0
 */
function reindexSlides() {
  // Reindex main slider
  $(".product-image-slider__body .slick-slide").each(function(index) {
    $(this).attr('data-slick-index', index);
  });
  
  // Reindex thumbnail slider
  $(".product-image-slider__thumbnails .slick-slide").each(function(index) {
    $(this).attr('data-slick-index', index);
  });
}

/**
 * Reindex only the filtered/visible slides starting from 0
 */
function reindexFilteredSlides() {
  // Reindex visible slides in main slider
  $(".product-image-slider__body .slick-slide:not(.slick-cloned)").each(function(index) {
    if ($(this).is(':visible') || $(this).hasClass('variant-filter')) {
      $(this).attr('data-slick-index', index);
    }
  });
  
  // Reindex visible slides in thumbnail slider
  $(".product-image-slider__thumbnails .slick-slide:not(.slick-cloned)").each(function(index) {
    if ($(this).is(':visible') || $(this).hasClass('variant-filter')) {
      $(this).attr('data-slick-index', index);
    }
  });
}

// Fix for responsive screens - force a redraw of the thumbnails
if (window.innerWidth < 1200) {
  setTimeout(function() {
    $(".product-image-slider__thumbnails").slick('setPosition');
  }, 50);
}

// Custom implementation of focusOnSelect functionality since it is no longer supported by Slick
$(document).ready(function() {
  // Add click event to thumbnail slides
  $(document).on('click', '.product-image-slider__thumbnails .slick-slide', function(e) {
    e.preventDefault();
    // Read index from attribute to avoid stale jQuery data after reindexing
    var rawIndex = $(this).attr('data-slick-index');
    var index = rawIndex !== undefined ? parseInt(rawIndex, 10) : $(this).data('slick-index');
    if (!Number.isFinite(index)) return;
     
    // Go to the corresponding slide in the main slider
    if ($('.product-image-slider__body').hasClass('slick-initialized')) {
      var $main = $('.product-image-slider__body');
      var current = $main.slick('slickCurrentSlide');
      if (index === current) return; // Already on this slide; do nothing
      $main.slick('slickGoTo', index);
       
      // Add active class to the clicked thumbnail
      $('.product-image-slider__thumbnails .slick-slide').removeClass('slick-current');
      $(this).addClass('slick-current');
    }
  });

  // Keep thumbnails in sync when main slider changes programmatically
  $('.product-image-slider__body').on('afterChange', function(event, slick, currentSlide){
    var $thumbs = $('.product-image-slider__thumbnails .slick-slide');
    $thumbs.removeClass('slick-current');
    $thumbs.filter('[data-slick-index="' + currentSlide + '"]').addClass('slick-current');
  });
});


/*=====================
  #Lightbox Slider
=====================*/
var zoomSlider;

// Function to apply filtering to the zoom slider based on current variant selection
function applyZoomSliderFiltering() {
  // Reset any previous filtering
  zoomSlider.slick('slickUnfilter');
  $('.zslick-filter-image').removeClass('filter');
  
  // Get the variant filtering information
  var filterIndexes = [];
  
  // Collect all option values from the variant
  $(".swatch").each(function (index, item) {
    var optionName = $(item).data("option-name") ? $(item).data("option-name").toLowerCase() : '';
    
    if (optionName == "size" || optionName == "color" || optionName == 'finish') {
      if ($(this).data("file-alt") != undefined && optionName == 'size') {
        // Using Metafields ignoring size (Put in Place for Dearfoams and Baggalinni)
      } else {
        filterIndexes.push(index + 1);
      }
    }
  });
  
  var fileName = "";
  
  if (filterIndexes.length > 0) {
    var fileNameParts = []; // Use array to collect parts, then join
    
    $(filterIndexes).each(function (index, item) {
      var vName = $('.product-form__input[data-option-index="' + (item - 1) + '"] input:checked');
      
      // Check if vName exists and has elements before accessing properties
      if (vName.length > 0 && vName[0]) {
        var vNameFinal = vName[0].defaultValue;
        vNameFinal = vNameFinal.replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
        fileNameParts.push(vNameFinal); // Add to array instead of concatenating
      }
    });
    
    // Join the parts with hyphens, this prevents trailing hyphens
    fileName = fileNameParts.join('-');
  }
  
  // Convert filename to lowercase for case-insensitive comparison
  fileName = fileName.toLowerCase();
  
  // Filter the zoom slider images based on the selected variant
  let matchCount = 0;
  $(".zslick-filter-image").each(function (index) {
    var dataFile;
    var $img = $(this);
    
    if ($img.data("file-alt") != undefined) {
      dataFile = $img.data("file-alt").toString().toLowerCase().replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
    } else {
      dataFile = $img.data("file-name") ? $img.data("file-name").toString().toLowerCase() : '';
    }
    
    // If the filename contains our variant info or there's no variant filtering needed
    var matches = dataFile.indexOf(fileName) > -1 || fileName === "";
    if (matches) {
      $(this).addClass("filter");
      matchCount++;
    }
  });
  
  // Apply the filter if we have matches
  if ($(".filter").length > 0) {
    zoomSlider.slick("slickFilter", ".filter");
    
    // Re-index the slides after filtering
    $(".zoom-image-slider__body .slick-slide").each(function (index) {
      $(this).attr("data-slick-index", index);
    });
  }
}

$('.product-image-slider__body--image img, .slider-zoom-icon').on('click', function () { 
  // Get the clicked image's index
  var clickedElement = $(this);
  var activeSlide;
  var slideIndex;
  
  // Determine if we clicked on an image or the zoom icon
  if (clickedElement.hasClass('slider-zoom-icon')) {
    // If zoom icon was clicked, get the currently active slide
    activeSlide = clickedElement.closest('.product-image-slider').find('.product-image-slider__body .slick-active')[0];
  } else {
    // If image was clicked, get the slide containing this image
    activeSlide = clickedElement.closest('.slick-slide')[0];
  }
  
  // Get the slide index
  slideIndex = $(activeSlide).data('slick-index');
  
  // Show the zoom slider overlay
  $('.zslider-blackout').removeClass('hidden');
  $('body').addClass('locked');
  window.scrollTo(0, 0);
  
  // Initialize the zoom slider if it doesn't exist
  if (!zoomSlider) {
    zoomSlider = $('.zoom-image-slider__body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      speed: 0,
      responsive: [{
        breakpoint: 769,
        settings: {}
      }]
    });
    
    // Add event to handle filtering when navigating between zoomed images
    zoomSlider.on('afterChange', function(event, slick, currentSlide) {
      if (!$('.zslider-blackout').hasClass('hidden')) {
        applyZoomSliderFiltering();
      }
    });
  }
  
  // Apply filtering to the zoom slider
  applyZoomSliderFiltering();
  
  // Find the correct index in the filtered zoom slider
  var targetFilteredIndex = 0; // Default to first image
  
  // Get the clicked image's data to match it in the zoom slider
  var clickedImg = $(activeSlide).find('img');
  var clickedImgSrc = clickedImg.attr('src') || '';
  var clickedImgAlt = clickedImg.attr('alt') || '';
  
  // Find the matching image in the filtered zoom slider
  $('.zoom-image-slider__body .slick-slide.filter').each(function(index) {
    var zoomImg = $(this).find('img');
    var zoomImgSrc = zoomImg.attr('src') || '';
    var zoomImgAlt = zoomImg.attr('alt') || '';
    
    // Check if this zoom image matches the clicked image
    if (zoomImgSrc.indexOf(clickedImgSrc.split('?')[0]) > -1 || 
        zoomImgAlt === clickedImgAlt ||
        clickedImgSrc.indexOf(zoomImgSrc.split('?')[0]) > -1) {
      targetFilteredIndex = index;
      return false; // Break out of each loop
    }
  });
  
  // Go to the correct slide in the filtered zoom slider
  zoomSlider.slick('slickGoTo', targetFilteredIndex);
});

if (zoomSlider) {}
  // Close the zoom slider when clicking the close button
  $('body').on('click', '.close-zoom', function() {
    $('.zslider-blackout').addClass('hidden');
    $('body').removeClass('locked');
    zoomSlider.slick("slickUnfilter");
  });

  $('body').on('click', '.zslider-blackout', function(e) {
    // Only close if the click was directly on the blackout (not on its children)
    if (e.target === this) {
      $('.zslider-blackout').addClass('hidden');
      $('body').removeClass('locked');
      zoomSlider.slick("slickUnfilter");
    }
  });

  $(document).keyup(function(e) {
    if (e.key === "Escape" && !$('.zslider-blackout').hasClass('hidden')) {
      $('.zslider-blackout').addClass('hidden');
      $('body').removeClass('locked');
      zoomSlider.slick("slickUnfilter");
    }
  });


/*===========================
  Variant Selection Code
============================*/
/*==========Variant Selection Code==========*/

// Add this section after your existing selectCallback function

// SWATCHES
jQuery(function () {
  jQuery(".swatch :radio").change(function () {
    var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
  });
});

/* set initial variant options as selected */
document.addEventListener('DOMContentLoaded', () => {
  const productSelect = document.querySelector('select[name="id"]');
  if (productSelect) {
    const selectedIndex = productSelect.selectedIndex;
    if (selectedIndex > 0) {
      const selectedOptions = productSelect.options[selectedIndex].text.split("/");
      for (let key in selectedOptions) {
        const optionValue = selectedOptions[key].trim();
        const swatchOptionInput = document.querySelector(`.swatch[data-option-index="${key}"] input[value="${optionValue}"]`);
        if (swatchOptionInput) {
          swatchOptionInput.checked = true;
          $(`.swatch[data-option-index="${key}"]`).trigger("change");
        }
      }
    }
  }
});

// Add the variant out of stock management functionality
var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = jQuery(".swatch:eq(0) :checked");
      break;
    case 1:
      var key = jQuery(".swatch:eq(0) input:checked").val();
      var selector = jQuery(".swatch:eq(1) :checked");
      break;
    case 2:
      var key = jQuery(".swatch:eq(0) :checked").val();
      key += " / " + jQuery(".swatch:eq(1) :checked").val();
      var selector = jQuery(".swatch:eq(2) :checked");
  }
  var initialValue = selector.val();
  var availableOptions = Shopify.optionsMap[key] || [];
  var firstOption = true;
  
  jQuery(`.swatch[data-option-index="${selectorIndex}"] .variant-picker-body__swatch--input`).each(
    function (index) {
      if (jQuery.inArray($(this).val(), availableOptions) !== -1) {
        $(this)
          .removeClass("soldout")
          .removeAttr("disabled", "disabled")
          .removeAttr("checked");
          if(firstOption){
            $(this).click();
            firstOption = false;
          }
      } else {
        $(this)
          .addClass("soldout")
          .removeAttr("checked")
          .attr("disabled", "disabled");
      }
    }
  );
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.attr("checked");
  }
};

Shopify.linkOptionSelectors = function (product) {
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
  // When there is an update in the first dropdown.
  jQuery(".swatch:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
  // When there is an update in the second dropdown.
  jQuery(".swatch:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

// Helper function to handle unique arrays
Shopify.uniq = function (array) {
  return array.filter(function (item, pos) {
    return array.indexOf(item) == pos;
  });
};

// Add this helper function for triggering the picker select
function triggerPickerSelect() {
  const colorPicker = $('input[name="Color"].checked');
  const sizePicker = $('input[name="Size"].checked');
  if (colorPicker.length > 0) {
    colorPicker.trigger('click');
  }
  if (sizePicker.length > 0) {
    setTimeout(() => {
      sizePicker.trigger('click');
    }, 10);
  }
}

// Enhanced function to visually select the first available variant on page load
function selectFirstAvailableVariant() {
  const productSelect = document.querySelector('select[name="id"]');
  
  if (productSelect) {
    // Get variant data from Shopify (usually available in variant-radios script tag)
    let variantData = [];
    const variantScript = document.querySelector('#variantObjectData');
    if (variantScript) {
      try {
        const parsedData = JSON.parse(variantScript.textContent);
        console.log('Parsed variant data:', parsedData); // Debug log
        
        // Handle different possible data structures
        if (Array.isArray(parsedData)) {
          variantData = parsedData;
        } else if (parsedData && parsedData.variants && Array.isArray(parsedData.variants)) {
          variantData = parsedData.variants;
        } else if (parsedData && typeof parsedData === 'object') {
          // If it's an object, try to extract variants or convert to array
          variantData = Object.values(parsedData).filter(item => item && item.id);
        }
        
        console.log('Final variantData:', variantData); // Debug log
      } catch (e) {
        console.warn('Could not parse variant data:', e);
      }
    }
    
    // If there's already a selected variant, check if it's available
    const selectedIndex = productSelect.selectedIndex;

    if (selectedIndex > 0) {
      const selectedOption = productSelect.options[selectedIndex];
      const selectedVariantId = parseInt(selectedOption.value);
      
      // Check if the currently selected variant is available
      let selectedVariant = null;
      let isSelectedAvailable = false;
      
      if (Array.isArray(variantData) && variantData.length > 0) {
        selectedVariant = variantData.find(v => v && v.id === selectedVariantId);
        isSelectedAvailable = selectedVariant ? selectedVariant.available : false;
      } else {
        // Fallback to disabled check
        isSelectedAvailable = !selectedOption.disabled; 
      }
      
      if (isSelectedAvailable) {
        // Current selection is available, apply visual selection
        const selectedOptions = selectedOption.text.split("/");
        
        for (let key in selectedOptions) {
          const optionValue = selectedOptions[key].trim();
          const swatchOptionInput = document.querySelector(`.swatch[data-option-index="${key}"] input[value="${optionValue}"]`);
          
          if (swatchOptionInput) {
            swatchOptionInput.checked = true;
            $(swatchOptionInput).closest('.variant-picker-body__swatch').find('.variant-picker-body__swatch--input').addClass('checked');
            $(`.swatch[data-option-index="${key}"]`).trigger("change");
          }
        }
        return; // Exit early since current selection is valid
      }
    }

    // Find the first available variant
    for (let i = 0; i < productSelect.options.length; i++) {
      const option = productSelect.options[i];
      
      // Skip the "Select" option if it exists
      if (i === 0 && (option.text.toLowerCase().includes('select') || option.value === '')) {
        continue;
      }
      
      // Check if this variant is available using Shopify's variant data
      const variantId = parseInt(option.value);
      let variantAvailable = false;
      
      if (Array.isArray(variantData) && variantData.length > 0) {
        // Use Shopify's variant data for accurate availability
        const variant = variantData.find(v => v && v.id === variantId);
        variantAvailable = variant ? variant.available : false;
      } else {
        // Fallback to checking disabled state
        variantAvailable = !option.disabled;
      }
      // console.log(`Checking variant ${i}: ID=${variantId}, Available=${variantAvailable}, Text="${option.text}"`); // Debug log
      
      if (variantAvailable) {
        // console.log(`Selecting first available variant: ${option.text} (ID: ${variantId})`); // Debug log
        
        // Select this variant in the dropdown
        productSelect.selectedIndex = i;
        
        // Get the variant object for image filtering
        const selectedVariant = Array.isArray(variantData) && variantData.length > 0 
          ? variantData.find(v => v && v.id === variantId)
          : null;
        
        // Apply visual selection to swatches
        const selectedOptions = option.text.split("/");
        
        for (let key in selectedOptions) {
          const optionValue = selectedOptions[key].trim();
          const swatchOptionInput = document.querySelector(`.swatch[data-option-index="${key}"] input[value="${optionValue}"]`);
          
          if (swatchOptionInput) {
            swatchOptionInput.checked = true;
            $(swatchOptionInput).closest('.variant-picker-body__swatch').find('.variant-picker-body__swatch--input').addClass('checked');
            $(`.swatch[data-option-index="${key}"]`).trigger("change");
          }
        }
        
        // Trigger change on the product select to update prices, etc.
        $(productSelect).trigger('change');
        
        // Filter product images to match the selected variant
        if (selectedVariant && typeof filterProductImages === 'function') {
          filterProductImages(selectedVariant);
        }
        
        // console.log(`Successfully selected variant at index ${i}`); // Debug log
        return; // Exit the function immediately after selecting the first available variant
      } else {
        // console.log("Variant Unavailable");
      }
    }
  }
}

// Add this to your document ready function
$(document).ready(function() {
  // Your existing initialization code
  
  // Initialize variant swatch selection indicator
  $(".variant-picker-body__swatch--input").on("click", function () {
    $(".variant-picker-body__swatch--input").removeClass("checked");
    $(this).addClass("checked");
  });
  
  // Select the first available variant and apply visual indication
  selectFirstAvailableVariant();
  
  // For backward compatibility
  // triggerPickerSelect();
});

/*=================
  #Add To Cart 
====================*/


$(document).ready(function() {
  $(document).on("submit", "form[action='/cart/add']", function(e) {
    e.preventDefault();
    const form = this;
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }        
    })
    .then(response => response.json())
    .then(data => {
      if (cartContainsProductType(data, 'Swatch')){
        //cart has other products, cannot add swatches. Show modal with notice.
        const swatchNoticeModal = new bootstrap.Modal(document.getElementById('swatchNoticeModal'));
        const modalBodyText = 'Products cannot be ordered with Swatches. To order your product(s),  please remove all other swatches from your cart and complete the checkout.';
        document.querySelector('#swatchNoticeModal .modal-body--text').innerHTML = modalBodyText;
        swatchNoticeModal.show();              
      }
      else {
        addRegularItemsToCart(form);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      // Handle error
      $("#AddToCartErr .modal-title").html(error.message);
      $("#AddToCartErr .modal-body").html(error.description);
      $("#cart-overlay").fadeOut();
      modal.show();
    });            
  });
});

function addRegularItemsToCart(form){
  // Get the quantity value directly
  var quantity = parseInt($('.quantity-snippet-body__input').val());
  var variantId = $(form).find('[name="id"]').val();
  var subscriptionTerm = $(form).find('[name="properties[_Subscription Term]"]').val();
  
  var data = {
    id: variantId,
    quantity: quantity,
    properties: {
      '_Subscription Term': subscriptionTerm
    }
  };
  
  $("#cart-overlay").show();
  
  // AJAX Add To Cart
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: data,
    dataType: "json",
    success: function(response) {
      $(document).trigger("requestCartUpdate");
      // Open the cart drawer after adding the item
      setTimeout(function() {
        openCart();
      }, 300); // Small delay to allow the cart to update
    },
    error: function(err) {
      var response = JSON.parse(err.responseText);
      $("#AddToCartErr .modal-title").html(response.message);
      $("#AddToCartErr .modal-body").html(response.description);
      $("#cart-overlay").fadeOut();
      var modal = new bootstrap.Modal(document.getElementById("AddToCartErr"));
      modal.show();
    }
  });
}

/*================
  #SLIDERS
================*/

// FEATURED COLLECTION

$(".featured-collection--slider").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        centerMode: true,
        dots: true,
      },
    },
  ],
});

// TABBED FEATURED SLIDER



// PRODUCT IMAGE SLIDER

$(".product-image-slider__body").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: false,
  fade: true,
  asNavFor: ".product-image-slider__thumbnails",
});

$(".product-image-slider__thumbnails").slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: ".product-image-slider__body",
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  vertical: true,
  infinite:false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: false,
        arrows: false,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: false,
      },
    },
  ],
});


//////////////////////////////////////////////
//    Tabbed Featured Collection Slider    //
////////////////////////////////////////////

$(".tfc--navigation-slider").slick({
  slidesToShow: 6,
  slidesToScroll: 2,
  // asNavFor: ".product-image-slider__body",
  dots: false,
  centerMode: false,
  infinite: false,
  arrows: false,
  cssEase: 'linear',
  speed: 300,
  variableWidth: true,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
});


/*======================
  #COMPARE PRODUCTS
=======================*/
$(document).ready(function() {      
   const compareCheckboxes = document.querySelectorAll('.compare-checkbox');
   const compareButton = document.getElementById('compare-button');   
   const collectionReturnButton = document.getElementById('collection-return-button');
   const urlParams = new URLSearchParams(window.location.search);
   const showCompare = urlParams.get('show_compare') === 'true';
   const compareProductIds = (urlParams.get('compare_product_ids')) ? urlParams.get('compare_product_ids').split(',') : [];   
   
   if (collectionReturnButton) {
    collectionReturnButton.addEventListener('click', function() {
      toggleCompareTable(false);
      toggleCollectionReturnButton(false);
    });
   }
   if (compareButton && compareCheckboxes.length > 0) {
    const updateCompareButton = () => {
      const checkedCount = document.querySelectorAll('.compare-checkbox:checked').length;
      if (checkedCount >= 1) {
        compareButton.classList.remove('d-none');
      } else {
        compareButton.classList.add('d-none');
      }
    };
    
    // Function to attach event listeners to all checkboxes
    const attachCheckboxListeners = () => {
      document.querySelectorAll('.compare-checkbox').forEach(checkbox => {
        // Remove any existing listeners to prevent duplicates
        checkbox.removeEventListener('change', updateCompareButton);
        // Add the event listener
        checkbox.addEventListener('change', updateCompareButton);
      });
    };
    
    // Initial setup
    if (compareProductIds.length === 0 && !showCompare) {
      updateCompareButton();
    }

    attachCheckboxListeners();    
    
    compareButton.addEventListener('click', function() {
        handleCompareButtonClickEvent();
    });

    // Handle browser back button and page visibility changes
    window.addEventListener('pageshow', function() {
      setTimeout(() => {
        if (compareProductIds.length === 0 && !showCompare) {
          updateCompareButton();
        }
        attachCheckboxListeners(); // Reattach listeners when page is shown
      }, 0);
    });
   }
   // Fix for sticky positioning in collection-nav **doesn't work still**
   // This ensures the sticky behavior works correctly by forcing a reflow
   window.addEventListener('load', function() {
     const stickyNav = document.querySelector('.collection-nav-sticky');
     if (stickyNav) {
       setTimeout(function() {
         stickyNav.style.position = 'relative';
         // Force a reflow
         void stickyNav.offsetHeight;
         stickyNav.style.position = 'sticky';
       }, 100);
     }
   });

   const handleCompareButtonClickEvent = (showCompare = false) => {
    const compareProducts = Array.from(compareCheckboxes).filter(checkbox => checkbox.checked).map(checkbox => parseInt(checkbox.dataset.productId));        
    if (compareProducts.length > 0 && compareProducts.length < 5) {
      window.targetProductIds = compareProducts;
    
      /* fill any remaining positions with null to ensure updates are applied consistently between both checkbox and dropdown updates */
      const productSelectors = document.querySelectorAll('.product-selector');
      const maxPositions = productSelectors.length;
      const positionedProductIds = new Array(maxPositions).fill(null);
      for (let i = 0; i < positionedProductIds.length; i++) {
        if ((window.targetProductIds.length - 1) < i) {
          window.targetProductIds.push(null);
        }
      }
      
      updateCompareTable();
      toggleCompareTable(true);
      toggleCollectionReturnButton(true);
      const compareProductsStrArr = compareProducts.filter(id => id !== null && id !== '').map(id => id.toString());
      updateDropdownOptionsVisibility(compareProductsStrArr);          
    }
    else if (showCompare) {
      toggleCompareTable(true);
      toggleCollectionReturnButton(true);
    }
    else if (compareProducts.length < 1) {
      alert('Please select at least 1 product to compare.')
    }
    else {
      alert('You can only compare up to 4 products.')
    }
   };

   const handleInitialCompareProduct = () => {    
    if (compareProductIds.length > 0) {  
      for (let i = 0; i < compareProductIds.length; i++) {
        const compareProductId = compareProductIds[i];
        const compareLinkCheckbox = document.querySelector(`input[data-product-id="${compareProductId}"]`);
        if (compareLinkCheckbox) {
          compareLinkCheckbox.checked = true;
        }
      }        
    }
    if (compareProductIds.length > 0 || showCompare) {
      handleCompareButtonClickEvent(showCompare);
    }
   };

   handleInitialCompareProduct();
});

function toggleCollectionReturnButton(show) {
  const collectionReturnButton = document.getElementById('collection-return-button');
  if (collectionReturnButton) {
    if (show) {
      collectionReturnButton.classList.remove('d-none');      
    } else {
      collectionReturnButton.classList.add('d-none');
      removeCompareProductUrlParam();
    }
  }
}

function setCompareProductUrlParams(productIds) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('compare_product_ids', productIds.join(','));
  const newUrl = (urlParams.size > 0) ? window.location.pathname + '?' + urlParams.toString() : window.location.pathname;
  window.history.replaceState(null, '', newUrl);
}
function removeCompareProductUrlParam() {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('compare_product_ids');
  urlParams.delete('show_compare');
  const newUrl = (urlParams.size > 0) ? window.location.pathname + '?' + urlParams.toString() : window.location.pathname;
  window.history.replaceState(null, '', newUrl);
}

function toggleCompareTable(show) {
  const compareButton = document.getElementById('compare-button');
  const collectionNav = document.querySelector('.collection-nav-wrapper');  
  const compareTableContainer = document.querySelector('.collection-compare-table--container');
  const compareGridContainer = document.querySelector('.collection-compare-grid--container');
  if (compareTableContainer) {
    if (show) {
        compareTableContainer.classList.remove('d-none');
    } else {
      compareTableContainer.classList.add('d-none');
    }
  }
  if (compareGridContainer) {
    if (show) {
      compareGridContainer.classList.add('d-none');
    } else {
      compareGridContainer.classList.remove('d-none');
    }
  }
  if (compareButton) {
    if (show) {
      compareButton.classList.add('d-none');
    } else {
      compareButton.classList.remove('d-none');
    }
  }
  if (collectionNav) {
    const breadcrumb = document.querySelector('.breadcrumb');    
    if (breadcrumb && compareButton) {
      const collectionTitle = breadcrumb.querySelector('span[data-collection]');      
      collectionTitle.innerHTML = (show) ? compareButton.getAttribute('data-compare-text') : collectionTitle.dataset.collection;
    }
  }
}

function updateCompareTable() {
  const targetProductIds = window.targetProductIds || [];

  let filteredProducts = [];

  // Check if we have target IDs and the product data array exists
  if (targetProductIds.length > 0 && window.productsWithMetafield) {
    // Filter the main product array

    filteredProducts = window.productsWithMetafield.filter(product => {
      // Keep the product if its ID is in our targetProductIds array
      return targetProductIds.includes(product.id);
    });
    $newFilteredProducts = [];
    targetProductIds.forEach(id => {      
      if (filteredProducts.find(product => product.id === id)) {
        $newFilteredProducts.push(filteredProducts.find(product => product.id === id));
      }
      else {
        $newFilteredProducts.push(null);
      }
    });
    filteredProducts = $newFilteredProducts;
  } else if (window.productsWithMetafield && targetProductIds.length === 0) {
    console.warn("No specific product IDs provided in URL parameter 'product_ids'.");
  } else {
    console.warn("Product data array 'window.productsWithMetafield' not found or parameter missing.");
  }

  // --- Use the filteredProducts array ---
  // console.log('Filtered Products:', filteredProducts);

  const compareTable = document.querySelector('.compare-table');
  const productComparisonFields = window.productComparisonFields || [];
  if (compareTable && productComparisonFields.length > 0) {
      if (filteredProducts.length > 0) {
        let index = 1;
        filteredProducts.forEach(product => {
          // console.log('Product:', product);
          const compareDropdown = compareTable.querySelector(`.product-col-${index} .product-selector`);
          const imgCell = compareTable.querySelector(`.product-img-col-${index}`);      
          const pdpLinkButton = compareTable.querySelector(`.pdp-link-row .product-col-${index} .pdp-link-row--button`);          
          if (!product) {
            updateCompareDropdown(compareDropdown, 'Select', null, null);   
            imgCell.innerHTML = '';
            pdpLinkButton.classList.add('d-none');
            productComparisonFields.forEach((field) => {
              const fieldCell = compareTable.querySelector(`td.product-col-${index}[data-field="${field}"] .data-row--value`);
              fieldCell.textContent = '';
            });
          }
          else {         
            updateCompareDropdown(compareDropdown, product.title, product.id, product.handle);   
                      
            imgCell.innerHTML = `<img src="${product.featured_image}" alt="${product.title}" class="img-fluid" width="200" height="auto">`;  
            pdpLinkButton.classList.remove('d-none');
            pdpLinkButton.setAttribute('href', `/products/${product.handle}`);   
            pdpLinkButton.querySelector('.button-text').textContent = `View ${product.title}`;   
            productComparisonFields.forEach((field) => {
              const fieldCell = compareTable.querySelector(`td.product-col-${index}[data-field="${field}"] .data-row--value`);
              fieldCell.textContent = product[field];
            });
          }
          index++;      
        });

        const productIdsParamStr = window.targetProductIds.filter(id => id !== null && id !== '').map(id => id.toString())
        setCompareProductUrlParams(productIdsParamStr);
      } else {
        compareTable.innerHTML = '<p>No matching products found for the specified IDs.</p>';
      }
    } else {
       console.warn("Display container '#compare-table' not found.");
    }

    highlightUnmatchedCells();
}

document.addEventListener('DOMContentLoaded', function() {
  // Get all dropdowns on the page
  const dropdowns = document.querySelectorAll('.product-selector');
  
  dropdowns.forEach(dropdown => {
      const dropdownItems = dropdown.querySelectorAll('.dropdown-item');      
      
      // Add click event to each dropdown item
      dropdownItems.forEach(item => {
          item.addEventListener('click', function(e) {
              e.preventDefault();
              
              // Get product data
              const position = dropdown.getAttribute('data-dropdown-position');
              const productId = this.getAttribute('data-product-id');
              const productHandle = this.getAttribute('data-product-handle');
              
              // update attributes and text of dropdown
              updateCompareDropdown(dropdown, this.textContent, productId, productHandle);   
              
              // Dispatch a custom event to notify that a product was selected
              const event = new CustomEvent('compare-product-selected');
              document.dispatchEvent(event);
          });
      });
  });

  // Add event listener for compare-product-selected event
  document.addEventListener('compare-product-selected', function(e) {    
    
    // Update data from selected dropdown products
    const selectedProductIds = compareProductDropdownChanged();

    // Update dropdown options visibility
    updateDropdownOptionsVisibility(selectedProductIds);
    
    // Update the compare table
    updateCompareTable();
  });
});

function compareProductDropdownChanged() {
  const productSelectors = document.querySelectorAll('.product-selector');

    // Reset all checkboxes
    document.querySelectorAll('.compare-checkbox').forEach(checkbox => {
      checkbox.checked = false;
    });
    
    // Reset targetProductIds and create a position-based array
    window.targetProductIds = [];
    
    // Create an array with position-specific slots
    const maxPositions = productSelectors.length;
    const positionedProductIds = new Array(maxPositions).fill(null);
    
    // First, collect all selected product IDs and place them in the correct position
    productSelectors.forEach(productSelector => {
      const selectedId = productSelector.getAttribute('data-selected-product-id');
      
      if (selectedId) {
        // Store in position-specific array
        positionedProductIds[productSelector.getAttribute('data-dropdown-position') - 1] = parseInt(selectedId);
      }
    });
    // console.log('positionedProductIds', positionedProductIds);
    // Filter out null values and set as targetProductIds
    window.targetProductIds = positionedProductIds
    
    // Collect for dropdown visibility (we need strings for querySelector)
    const selectedProductIds = Array.from(productSelectors)
      .map(selector => selector.getAttribute('data-selected-product-id'))
      .filter(id => id !== null && id !== '');

      // console.log('selectedProductIds', selectedProductIds);
    
    // Check corresponding checkboxes
    selectedProductIds.forEach(id => {
      const checkbox = document.querySelector(`.compare-checkbox[data-product-id="${id}"]`);
      if (checkbox) checkbox.checked = true;
    });

    // console.log('window.targetProductIds', window.targetProductIds);

    return selectedProductIds;
}

function highlightUnmatchedCells() {
  const compareTable = document.querySelector('.compare-table');
  if (compareTable) {
    const dataRows = compareTable.querySelectorAll('.data-row');
    dataRows.forEach(row => {
        const cells = row.querySelectorAll(`td[data-field] .data-row--value`);
        let lastCellContent = null;
        let rowHasUnmatchedCell = false;
        cells.forEach(cell => {
          const cellTextContent = cell.textContent.trim();
          if (cellTextContent) {
            if (lastCellContent === null) {
              lastCellContent = cellTextContent;
            }
            else {
              if (cellTextContent !== lastCellContent) {
                rowHasUnmatchedCell = true;
              }
            }
          }
        });

        if (rowHasUnmatchedCell) {
          cells.forEach(cell => {
            if (cell.textContent.trim()) {
              cell.parentElement.classList.add('unmatched');
            }
          });
        }
    });
  }
}

function updateCompareDropdown(dropdown, title, productId, productHandle) {
  const dropdownButton = dropdown.querySelector('.dropdown-toggle');
  const dropdownText = dropdownButton.querySelector('.custom-dropdown-text');
  if (productId) {
    dropdown.setAttribute('data-selected-product-id', productId);
    dropdown.setAttribute('data-selected-product-handle', productHandle);    
  }
  else {
    dropdown.removeAttribute('data-selected-product-id');
    dropdown.removeAttribute('data-selected-product-handle');
  }
  dropdownText.textContent = title;
}

/**
 * Updates the visibility of dropdown options based on selected products
 * @param {Array} selectedProductIds - Array of selected product IDs
 */
function updateDropdownOptionsVisibility(selectedProductIds) {
  const dropdowns = document.querySelectorAll('.product-selector');
  
  // First, show all options in all dropdowns
  dropdowns.forEach(dropdown => {
    const items = dropdown.querySelectorAll('.dropdown-item');
    items.forEach(item => {
      item.style.display = 'block';
    });
  });
  
  // Then hide options for products that are already selected in other dropdowns
  // console.log('hiding selected product ids from dropdowns', selectedProductIds);
  selectedProductIds.forEach(productId => {
    if (productId) {
      dropdowns.forEach(dropdown => {
          const items = dropdown.querySelectorAll('.dropdown-item');
          items.forEach(item => {
            if (item.getAttribute('data-product-id') === productId) {
              item.style.display = 'none';
            }
          });
      });
    }
  });
}

// Initialize drag and drop functionality for product comparison dropdowns
document.addEventListener('DOMContentLoaded', function() {
  initProductDropdownDragAndDrop();
});

function initProductDropdownDragAndDrop() {
  // Variables to track drag state
  let dragSource = null;
  let dragSourceRect = null;
  let dragGhost = null;
  let startX = 0;
  let startY = 0;
  let dropTarget = null;
  let productSelectors = document.querySelectorAll('.product-selector');
  
  // Initialize event listeners for all product selectors
  productSelectors.forEach(selector => {
    const moveIcon = selector.querySelector('.custom-dropdown-move-icon');
    if (!moveIcon) return;
    
    // Make the move icon draggable
    moveIcon.addEventListener('mousedown', startDrag);
    moveIcon.addEventListener('touchstart', startDrag, { passive: false });
  });
  
  /**
   * Start the drag operation
   * @param {Event} e - Mouse or touch event
   */
  function startDrag(e) {
    e.preventDefault();
    
    // Get coordinates
    if (e.type === 'touchstart') {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    } else {
      startX = e.clientX;
      startY = e.clientY;
    }
    
    // Get source dropdown
    dragSource = this.closest('.product-selector');
    dragSourceRect = dragSource.getBoundingClientRect();
    
    // Create ghost element
    dragGhost = dragSource.cloneNode(true);
    dragGhost.classList.add('dragging-ghost');
    dragGhost.style.width = dragSourceRect.width + 'px';
    dragGhost.style.height = dragSourceRect.height + 'px';
    document.body.appendChild(dragGhost);
    
    // Position the ghost at the original position
    updateGhostPosition(e);
    
    // Add dragging class to source
    dragSource.classList.add('dragging');
    
    // Add event listeners for dragging
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('touchmove', onDrag, { passive: false });
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
    
    // Mark other selectors as potential drop targets
    productSelectors.forEach(selector => {
      if (selector !== dragSource) {
        selector.classList.add('drop-target');
      }
    });
  }
  
  /**
   * Update the ghost element position during drag
   * @param {Event} e - Mouse or touch event
   */
  function updateGhostPosition(e) {
    let clientX, clientY;
    
    if (e.type === 'touchmove' || e.type === 'touchstart') {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    const offsetX = clientX - startX;
    const offsetY = clientY - startY;
    
    dragGhost.style.left = (dragSourceRect.left + offsetX) + 'px';
    dragGhost.style.top = (dragSourceRect.top + offsetY) + 'px';
  }
  
  /**
   * Handle the drag movement
   * @param {Event} e - Mouse or touch event
   */
  function onDrag(e) {
    e.preventDefault();
    
    // Update ghost position
    updateGhostPosition(e);
    
    // Find the closest dropdown as potential drop target
    const lastDropTarget = dropTarget;
    dropTarget = findDropTarget(e);
    
    // Update highlighting
    if (lastDropTarget && lastDropTarget !== dropTarget) {
      lastDropTarget.classList.remove('active-drop-target');
    }
    
    if (dropTarget && dropTarget !== dragSource) {
      dropTarget.classList.add('active-drop-target');
    }
  }
  
  /**
   * Find the closest dropdown to the cursor as a potential drop target
   * @param {Event} e - Mouse or touch event
   * @returns {Element} The potential drop target element
   */
  function findDropTarget(e) {
    let clientX, clientY;
    
    if (e.type === 'touchmove') {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    // Find the closest selector to the cursor
    let closestSelector = null;
    let closestDistance = Infinity;
    
    productSelectors.forEach(selector => {
      if (selector === dragSource) return;
      
      const rect = selector.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      const distance = Math.sqrt(
        Math.pow(clientX - centerX, 2) + 
        Math.pow(clientY - centerY, 2)
      );
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSelector = selector;
      }
    });
    
    return closestSelector;
  }
  
  /**
   * End the drag operation and handle the drop
   */
  function endDrag() {
    // Clean up event listeners
    document.removeEventListener('mousemove', onDrag);
    document.removeEventListener('touchmove', onDrag);
    document.removeEventListener('mouseup', endDrag);
    document.removeEventListener('touchend', endDrag);
    
    // Remove the ghost element
    if (dragGhost && dragGhost.parentNode) {
      dragGhost.parentNode.removeChild(dragGhost);
    }
    
    // Remove drag and drop classes
    dragSource.classList.remove('dragging');
    
    productSelectors.forEach(selector => {
      selector.classList.remove('drop-target');
      selector.classList.remove('active-drop-target');
    });
    
    // If we have a valid drop target, swap the positions
    if (dropTarget && dropTarget !== dragSource) {
      // console.log('Swapping positions:', dragSource.getAttribute('data-dropdown-position'), dropTarget.getAttribute('data-dropdown-position'));
      reorderDropdowns(dragSource, dropTarget);
    }
    
    // Reset variables
    dragSource = null;
    dragSourceRect = null;
    dragGhost = null;
    dropTarget = null;
  }
  
  /**
   * Reorder the product data between two dropdowns
   * @param {Element} dropdown1 - First dropdown
   * @param {Element} dropdown2 - Second dropdown
   */
  function reorderDropdowns(dropdown1, dropdown2) {
    // Get position attributes as integers
    const sourcePos = parseInt(dropdown1.getAttribute('data-dropdown-position'));
    const targetPos = parseInt(dropdown2.getAttribute('data-dropdown-position'));
    
    if (sourcePos === targetPos) return; // No change needed
    
    // console.log(`Reordering dropdowns: moving position ${sourcePos} to position ${targetPos}`);
    
    // Get all product selectors/dropdowns in order
    const allDropdowns = Array.from(document.querySelectorAll('.product-selector'))
      .sort((a, b) => {
        return parseInt(a.getAttribute('data-dropdown-position')) - parseInt(b.getAttribute('data-dropdown-position'));
      });
    
    // Store the data from all dropdowns before making any changes
    const dropdownsData = [];
    
    allDropdowns.forEach(dropdown => {
      const position = parseInt(dropdown.getAttribute('data-dropdown-position'));
      const productId = dropdown.getAttribute('data-selected-product-id');
      const productHandle = dropdown.getAttribute('data-selected-product-handle');
      const text = dropdown.querySelector('.custom-dropdown-text').textContent;
      
      dropdownsData.push({
        position,
        productId,
        productHandle,
        text
      });
      
      // console.log(`Initial state - Position ${position}: ${text} (ID: ${productId || 'none'})`);
    });
    
    // Store the source dropdown data
    const sourceData = dropdownsData.find(data => data.position === sourcePos);
    
    // Reorder the data array based on the drag and drop action
    if (sourcePos < targetPos) {
      // Moving down: shift items up between source and target
      // console.log('Moving down: shifting intermediate positions up');
      for (let i = sourcePos; i < targetPos; i++) {
        const currentDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === i);
        const nextDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === i + 1);
        
        if (currentDropdown && nextDropdown) {
          // Get data from the next position
          const nextData = dropdownsData.find(data => data.position === i + 1);
          
          // Update the current dropdown with the next dropdown's data
          if (nextData && nextData.productId) {
            // console.log(`Moving data from position ${i+1} to position ${i}`);
            updateCompareDropdown(currentDropdown, nextData.text, nextData.productId, nextData.productHandle);
          } else {
            updateCompareDropdown(currentDropdown, 'Select', null, null);
          }
        }
      }
      
      // Put the source item at the target position
      const targetDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === targetPos);
      if (targetDropdown && sourceData) {
        // console.log(`Moving source data to target position ${targetPos}`);
        if (sourceData.productId) {
          updateCompareDropdown(targetDropdown, sourceData.text, sourceData.productId, sourceData.productHandle);
        } else {
          updateCompareDropdown(targetDropdown, 'Select', null, null);
        }
      }
    } else {
      // Moving up: shift items down between target and source
      // console.log('Moving up: shifting intermediate positions down');
      for (let i = sourcePos; i > targetPos; i--) {
        const currentDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === i);
        const prevDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === i - 1);
        
        if (currentDropdown && prevDropdown) {
          // Get data from the previous position
          const prevData = dropdownsData.find(data => data.position === i - 1);
          
          // Update the current dropdown with the previous dropdown's data
          if (prevData && prevData.productId) {
            // console.log(`Moving data from position ${i-1} to position ${i}`);
            updateCompareDropdown(currentDropdown, prevData.text, prevData.productId, prevData.productHandle);
          } else {
            updateCompareDropdown(currentDropdown, 'Select', null, null);
          }
        }
      }
      
      // Put the source item at the target position
      const targetDropdown = allDropdowns.find(dropdown => parseInt(dropdown.getAttribute('data-dropdown-position')) === targetPos);
      if (targetDropdown && sourceData) {
        // console.log(`Moving source data to target position ${targetPos}`);
        if (sourceData.productId) {
          updateCompareDropdown(targetDropdown, sourceData.text, sourceData.productId, sourceData.productHandle);
        } else {
          updateCompareDropdown(targetDropdown, 'Select', null, null);
        }
      }
    }
    
    // Log the final state after reordering
    allDropdowns.forEach(dropdown => {
      const position = parseInt(dropdown.getAttribute('data-dropdown-position'));
      const productId = dropdown.getAttribute('data-selected-product-id');
      const text = dropdown.querySelector('.custom-dropdown-text').textContent;
      // console.log(`Final state - Position ${position}: ${text} (ID: ${productId || 'none'})`);
    });
    
    // Notify of dropdown changes and update the comparison table
    compareProductDropdownChanged();
    updateCompareTable();
  }
}


/*=======================
  #ADDON ACCESSORIES
=======================*/

// Accessory product handling for cart
function handleAccessoryAddToCart() {
  // Get the product form
  const productForm = document.querySelector('form[action="/cart/add"]');
  
  // Get all accessory checkboxes
  const accessoryCheckboxes = document.querySelectorAll('.accessory-checkbox');
  
  // Only proceed if we have both the form and checkboxes
  if (productForm && accessoryCheckboxes.length > 0) {
    productForm.addEventListener('submit', function(event) {
      // Prevent the default form submission
      event.preventDefault();
      
      // Get the selected accessories
      const selectedAccessories = [];
      accessoryCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          selectedAccessories.push({
            id: checkbox.getAttribute('data-variant-id'),
            quantity: 1,
            properties: {
              'Added as accessory': 'Yes'
            }
          });
        }
      });
      
      // Show loading state
      const submitButton = productForm.querySelector('input[type="submit"]');
      const originalButtonText = submitButton.value;
      submitButton.value = 'Adding...';
      submitButton.disabled = true;
      
      // First, check the current cart to see if the main product already exists
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          // Get the variant ID from the form
          const formData = new FormData(productForm);
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity') || 1);
          
          // Check if this variant already exists in the cart
          let existingItem = null;
          let existingItemIndex = -1;
          
          for (let i = 0; i < cart.items.length; i++) {
            const item = cart.items[i];
            // Check if this is the same variant and doesn't have the "Added as accessory" property
            if (item.variant_id.toString() === variantId.toString() && 
                (!item.properties || !item.properties['Added as accessory'])) {
              existingItem = item;
              existingItemIndex = i + 1; // Shopify uses 1-based indexing for line items
              break;
            }
          }
          
          if (existingItem) {
            // Update the existing item's quantity
            const newQuantity = existingItem.quantity + quantity;
            
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                line: existingItemIndex,
                quantity: newQuantity
              },
              dataType: 'json',
              success: function(updatedCart) {
                // Now add the accessories if any
                if (selectedAccessories.length === 0) {
                  submitButton.value = originalButtonText;
                  submitButton.disabled = false;
                  updateCartDrawer();
                  return;
                }
                
                // Add accessories to cart
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: JSON.stringify({
                    items: selectedAccessories
                  }),
                  contentType: 'application/json',
                  dataType: 'json',
                  success: function(result) {
                    submitButton.value = originalButtonText;
                    submitButton.disabled = false;
                    updateCartDrawer();
                  },
                  error: function(error) {
                    console.error('Error adding accessories to cart:', error);
                    submitButton.value = originalButtonText;
                    submitButton.disabled = false;
                    
                    const errorMessage = document.createElement('div');
                    errorMessage.className = 'text-danger mt-2';
                    errorMessage.textContent = 'There was an error adding accessories to cart. Please try again.';
                    productForm.appendChild(errorMessage);
                    
                    setTimeout(() => {
                      errorMessage.remove();
                    }, 5000);
                    
                    updateCartDrawer();
                  }
                });
              },
              error: function(error) {
                console.error('Error updating cart:', error);
                // Fall back to adding as a new item
                addMainProductAndAccessories();
              }
            });
          } else {
            // Add as a new item
            addMainProductAndAccessories();
          }
        },
        error: function(error) {
          console.error('Error getting cart:', error);
          // Fall back to adding as a new item
          addMainProductAndAccessories();
        }
      });
      
      // Function to add the main product and accessories as new items
      function addMainProductAndAccessories() {
        const formData = new FormData(productForm);
        
        // Add the main product to cart
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formData,
          processData: false,
          contentType: false,
          dataType: 'json',
          success: function(result) {
            // If there are no accessories selected, update cart drawer and finish
            if (selectedAccessories.length === 0) {
              submitButton.value = originalButtonText;
              submitButton.disabled = false;
              updateCartDrawer();
              return;
            }
            
            // Add accessories to cart
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: JSON.stringify({
                items: selectedAccessories
              }),
              contentType: 'application/json',
              dataType: 'json',
              success: function(result) {
                // Reset button state
                submitButton.value = originalButtonText;
                submitButton.disabled = false;
                
                // Update and open the cart drawer
                updateCartDrawer();
              },
              error: function(error) {
                console.error('Error adding accessories to cart:', error);
                submitButton.value = originalButtonText;
                submitButton.disabled = false;
                
                // Show error message
                const errorMessage = document.createElement('div');
                errorMessage.className = 'text-danger mt-2';
                errorMessage.textContent = 'There was an error adding accessories to cart. Please try again.';
                productForm.appendChild(errorMessage);
                
                // Remove error message after 5 seconds
                setTimeout(() => {
                  errorMessage.remove();
                }, 5000);
                
                // Still update cart drawer with main product
                updateCartDrawer();
              }
            });
          },
          error: function(error) {
            console.error('Error adding main product to cart:', error);
            submitButton.value = originalButtonText;
            submitButton.disabled = false;
            
            // Show error message
            const errorMessage = document.createElement('div');
            errorMessage.className = 'text-danger mt-2';
            errorMessage.textContent = 'There was an error adding the product to cart. Please try again.';
            productForm.appendChild(errorMessage);
            
            // Remove error message after 5 seconds
            setTimeout(() => {
              errorMessage.remove();
            }, 5000);
          }
        });
      }
    });
  }
}

// Call the function when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  handleAccessoryAddToCart();
});


/*================================
  #TABBED FEATURED COLLECTION
================================*/

// Define slider settings once to reuse
const tabbedSliderSettings = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  // mobileFirst: true,
  centerMode: false,
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
        dots: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
      },
    },
    // {
    //   breakpoint:992,
    //   settings: "unslick"
    // },
  ],
};

// Initialize the first visible slider on page load
$(document).ready(function() {
  $('.tfc--product-row__products:not(.hidden) .tabbed-featured-slider').slick(tabbedSliderSettings);
  
  // Add active class to the first tab
  $('.tfc--navigation-row__item:first').addClass('active');
});

// Handle tab switching
$('.tfc--navigation-row__item').on('click', function() {
  // Update active tab
  $('.tfc--navigation-row__item').removeClass('active');
  $(this).addClass('active');
  
  let collection = $(this).data('collection');
  
  // Try to unslick any existing sliders (using try-catch to handle case where slider isn't initialized)
  try {
    $('.tabbed-featured-slider').slick('unslick');
  } catch (e) {
    console.log('No active sliders to unslick');
  }
  
  // Hide all product rows
  $('.tfc--product-row__products').addClass('hidden');
  
  // Show the selected collection
  $('.tfc--product-row__products.'+collection).removeClass('hidden');
  
  // Initialize slick on the visible slider
  $('.tfc--product-row__products.'+collection+' .tabbed-featured-slider').slick(tabbedSliderSettings);
});

/*===================================
  #Product Recommendations Slider
  ================================*/

document.addEventListener("DOMContentLoaded", function() {
  const productRecommendationsSection = document.querySelector(".product-recommendations");
  
  if (productRecommendationsSection) {
    const loadProductRecommendations = function() {
      const url = productRecommendationsSection.dataset.url;
      
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".product-recommendations");
          
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            
            // Initialize slick slider
            $(".product-recommendations-slider").slick({
              infinite: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    dots: true
                  }
                }
              ]
            });
          }
        })
        .catch(error => console.error("Error loading product recommendations:", error));
    };
    
    // Use Intersection Observer to load recommendations when visible
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        observer.unobserve(productRecommendationsSection);
        loadProductRecommendations();
      }
    }, {rootMargin: "0px 0px 200px 0px"});
    
    observer.observe(productRecommendationsSection);
  }
});

/*===================================
  #Product Order Swatches
  ================================*/
let selectedSwatchVariants = [];
const cartHolder = $('.ospc__holder');

document.addEventListener("DOMContentLoaded", function() {
  renderAllVariants();
});

$(document).on('click', '.osps__atc', function(){

    let vObject = $(this).data('variant-info');

    if (vObject) {

        const existingIndex = selectedSwatchVariants.findIndex(variant => variant.id === vObject.id);
        
        if (existingIndex !== -1) {
            $(this).find('.plus').removeClass('hidden');
            $(this).find('.minus').addClass('hidden');

            selectedSwatchVariants.splice(existingIndex, 1);
            
            cartHolder.find(`[data-variant-id="${vObject.id}"]`).remove();
            
            if (selectedSwatchVariants.length === 0) {
                cartHolder.html('<p>No swatches selected.</p>');
            }
            
        } else { 
            if(selectedSwatchVariants.length < 12){
                $(this).find('.plus').addClass('hidden');
                $(this).find('.minus').removeClass('hidden');

                if (cartHolder.find('p').length > 0) {
                    cartHolder.find('p').remove(); 
                }
                
                selectedSwatchVariants.push(vObject);
                
                appendVariant(vObject);
            }else{
                alert('You have reached the maximum of 12 swatches.');
            }
        }
        
        console.log('Selected Variants:', selectedSwatchVariants);
    } else {
        console.error('Error: Variant data could not be retrieved.');
    }
});


$(document).on('click', '.remove-from-cart', function() {
    const variantId = $(this).closest('.selected-item').data('variant-id');
    const existingIndex = selectedSwatchVariants.findIndex(variant => variant.id === variantId);

    if (existingIndex !== -1) {
        
        selectedSwatchVariants.splice(existingIndex, 1);

        
        $(this).closest('.selected-item').remove();

        
        const originalSwatch = $(`[data-variant-id="${variantId}"]`);
        originalSwatch.find('.plus').removeClass('hidden');
        originalSwatch.find('.minus').addClass('hidden');

        
        if (selectedSwatchVariants.length === 0) {
            cartHolder.html('<p class="mt-4 fs-4">Select Your Swatches</p>');
        }
        
    }
});

$(document).on('click', '.continue_button .btn', function() {
    if (selectedSwatchVariants.length === 0) {
        alert('Please select at least one swatch.');
    } 
    else if (selectedSwatchVariants.length > 12){
        alert('You can only have a maximum of 12 swatches.');
    }
    else {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }        
      })
      .then(response => response.json())
      .then(data => {
        console.log('cart data',data);
        if (data.item_count === 0){
          //cart is empty, can add swatches
          addSwatchesToCart(selectedSwatchVariants);
        }
        else{          
          if (cartDoesNotContainProductType(data, 'Swatch')){
            //cart has other products, cannot add swatches. Show modal with notice.
            const swatchNoticeModal = new bootstrap.Modal(document.getElementById('swatchNoticeModal'));
            const modalBodyText = 'Swatches cannot be ordered with other products. To order swatches, please remove all other items from your cart and complete the checkout.';
            document.querySelector('#swatchNoticeModal .modal-body--text').innerHTML = modalBodyText;
            swatchNoticeModal.show();
          }
          else if (cartContainsProductType(data, 'Swatch')) {
            fetch(window.Shopify.routes.root + 'cart/clear.js', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }        
            })
            .then(response => response.json())
            .then(data => {
              console.log('cart cleared',data);
              addSwatchesToCart(selectedSwatchVariants);
            })
            .catch(error => {
              console.error(error);
            });
          }
          else {
            addSwatchesToCart(selectedSwatchVariants);                        
          }
        }        
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle error
        $("#AddToCartErr .modal-title").html(error.message);
        $("#AddToCartErr .modal-body").html(error.description);
        $("#cart-overlay").fadeOut();
        modal.show();
      });
    }
});
function cartContainsProductType(cart, productType) {
  return cart.items.some(item => item.product_type === productType);
}
function cartDoesNotContainProductType(cart, productType) {
  return cart.items.some(item => item.product_type !== productType);
}
function appendVariant(variant){
  const variantHtml = `
    <div class="selected-item d-flex align-items-center mb-2 mt-3 position-relative" data-variant-id="${variant.id}">
        <img src="${variant.featured_image.src}" alt="${variant.title}" style="width: 50px; height: 50px; margin-right:20px;"><span>${variant.title}</span>
        <span class="remove-from-cart end-0 position-absolute" style="cursor:pointer;">
           <svg width="24px" height="24px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" d="M12.78 4.28a.75.75 0 00-1.06-1.06L8 6.94 4.28 3.22a.75.75 0 00-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 101.06 1.06L8 9.06l3.72 3.72a.75.75 0 101.06-1.06L9.06 8l3.72-3.72z"/></svg>
        </span>
    </div>`;

    cartHolder.append(variantHtml);
}

function renderAllVariants(){
  cartHolder.empty(); 
  cartHolder.html('<p class="mt-4 fs-4">Select Your Swatches</p>');
}
function addSwatchesToCart(swatchVariants) {

  $("#cart-overlay").show();

  let formData = {
      'items': []
  };

  swatchVariants.forEach(variant => {
    formData.items.push({
      'id': variant.id,
      'quantity': 1
    });
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  })
  .then(response => {
      console.log('atc response', response)
      if (!response.ok) {
          const error = new Error('Failed to add product to cart');
          error.description = response.statusText;
          throw error;
      }
      return response.json();
  })
  .then(() => {
      document.body.dispatchEvent(new CustomEvent('requestCartUpdate'));
  })
  .catch((error) => {
      console.error('Error:', error);
      // Handle error
      $("#AddToCartErr .modal-title").html(error.message);
      $("#AddToCartErr .modal-body").html(error.description);
      $("#cart-overlay").fadeOut();
      modal.show();
  });
}